export default {
  common: {
    appName: "布鲁街商家中心",
    appNameQrcode: "一物一码管理系统",
    example: "示例",
    mobile: "手机",
    cancelText: "取消",
    delete: "删除",
    developingFeature: "此功能正在开发中，敬请期待...",
    yuan: "元",
    minute: "分",
    dayUnit: "天",
    day: {
      1: "周一",
      2: "周二",
      3: "周三",
      4: "周四",
      5: "周五",
      6: "周六",
      7: "周日",
    },
    home: "首页",
    search: "搜索",
    statusLabel: "显示状态",
    refresh: "刷新",
    more: "更多",
    richTextPlaceHolder: "请输入内容",
    orderDescription: "数字越大排序越靠前",
    independentCommissionDescription:
      "如果设置独立分销比例，系统就会优先处理独立分销比例，不会按照用户的代理等级里的f分销比例, 例如这里设置比例后所有等级都会按照此比例来分销",
    yes: "是",
    no: "不是",
    inactive: "未上架",
    active: "已上架",
    save: "保存",
    saveSuccess: "保存成功",
  },
  base: {
    deliveryman: "配送员：",
    modal: {
      successTitle: "操作成功提示",
      errorTitle: "操作失败提示",
      warningTitle: "警告提示",
      infoTitle: "一般提示",
      confirmTitle: "是否确定继续当前的操作？",
      knowText: "知道了",
      okText: "确定",
      cancelText: "取消",
    },
    api: {
      err401:
        "抱歉，您的登录信息已经过期，为了保证您以后的操作的正常进行，请您重新登录更新您的登录信息",
      err408: "加载数据超时，请重试您的操作或者刷新该页面再试试",
      err422Title: "提供的数据不合法",
      err422Empty: "提供的数据不合法，请检查您的数据之后再试试",
      err429: "您的操作太频繁导致提供数据的服务器压力山大，请稍后重新操作试试",
      err500: "抱歉，服务器出现错误，请稍后再试试",
      err503: "抱歉，服务器出现错误，请稍后再试试",
      errUnknown: "加载数据出现错误，请重试您的操作或者刷新该页面再试试",
    },
  },
  notFound: {
    backToHome: "返回首页",
    backToPrev: "返回上一页",
    refresh: "刷新页面",
  },
  login: {
    titleImage: "/assets/images/login-title.png",
    phoneHint: "请输入手机号",
    phoneHintRequired: "请输入手机号",
    phoneHintPrefix: "手机号必须以1开头",
    phoneHintCount: "手机号必须是11位",
    parolHint: "请输入密码",
    parolHintRequired: "请输入密码",
    parolHintMin: "密码不能少于6位",
    parolHintMax: "密码不能多于16位",
    login: "登录",
    loggingin: "正在登录...",
    loginSuccess: "登录成功",
    title: "布鲁街商户中心",
    selectShop: "请选择店铺",
    enter: "进入",
    insertShopName: "请输入店铺名",
    password: "密码",
    reset: "重置密码",
    pass: "新密码",
    passAgain: "再次输入",
    notMatch: "两次输入不一致",
    forget: "忘记密码",
    codeHint: "请输入验证码",
    getCode: "获取验证码",
  },
  home: {
    chartTime: {
      week: "近7日",
      month: "近30天",
      season: "近90日",
    },
    loadingData: "正在加载统计数据...",
    loadingDataWarning: "正在加载统计数据，请稍后操作",
    numbers: {
      qrcode: "小程序二维码",
      dailyOrderCount: "今日有效订单数量",
      dailyOrderCountUnit: "单",
      yesterdayOrderCount: "昨日%{count}单",
      dailyOrderIncome: "今日订单收入",
      yesterdayOrderIncome: "昨日%{income}元",
      dailyOrderTurnover: "今日营业额",
      yesterdayOrderTurnover: "昨日%{income}元",
      monthlyOrderCount: "本月有效订单数量",
      monthlyOrderCountUnit: "单",
      prevMonthOrderCount: "上月%{count}单",
      monthlyOrderIncome: "本月订单收入",
      prevMonthOrderIncome: "上月%{income}元",
    },
    chart: {
      countTitle: "订单数量趋势",
      dateAlias: "日期",
      countAlias: "订单数量",
      incomeTitle: "订单营业额趋势",
      incomeAlias: "订单营业额",
    },
  },
  homeProductGroups: {
    addGroup: "添加分组",
    editGroup: "编辑分组",
    groupTitle: "分组标题",
    titleImage: "区块标题图",
    listType: "展示样式",
    onePerRow: "一行一个",
    twoPerRow: "一行两个",
    threePerRow: "一行三个",
    products: "商品列表",
    addProduct: "添加商品",
    productId: "商品ID",
    productCount: "商品数",
    productCountValue: "%{count} 件商品",
    moreProducts: "+%{count}",
    maxGroupsError: "最多只能添加 20 个分组",
    maxItemsError: "每组最多 50 个商品",
    itemsRequired: "请至少添加一个商品",
    saveSuccess: "保存成功",
    addSelectedCount: "添加已选 (%{count})",
    selectAtLeastOne: "请至少选择一个商品",
    alreadyAdded: "已添加",
    flashSaleType: "限时抢购分组",
    flashSaleHint: "开启后自动展示当前限时折扣商品，无需手动添加",
    flashSaleAutoProducts: "商品来自「营销管理 → 限时折扣」，请在那里维护活动商品",
    flashSaleBadge: "限时抢购",
    pageTitle: "首页商品分组",
    pageHint: "按顺序展示在小程序首页。可配置标题图、布局，或绑定限时抢购。",
    groupCount: "%{count} / %{max}",
    empty: "还没有分组，点击右上角添加",
    basicInfo: "基本信息",
    titleImages: "标题图（可选）",
    displaySettings: "展示设置",
    selectedProducts: "已选商品",
  },
  main: {
    sideMenus: {
      home: "商家首页",
      statistics: "数据统计",
      statisticsOverview: "经营概览",
      statisticsOrders: "订单统计",
      statisticsProducts: "商品统计",
      statisticsCommissions: "佣金统计",
      statisticsTransfers: "转账统计",
      delivery: "配送管理",
      order: "订单管理",
      orderList: "历史订单",
      printTemplates: "打印模板",
      refundList: "退款订单",
      downloadList: "导出表格",
      import: "导入表格",
      product: "商品管理",
      productList: "商品列表",
      productImport: "导入商品",
      productUnits: "单位管理",
      manageAds: "广告管理",
      sales: "营销管理",
      coupons: "优惠券",
      holiday: "折扣页面",
      flash: "限时折扣",
      gift: "赠品管理",
      groupon: "团购",
      grouponDeals: "套餐管理",
      grouponOrders: "订单管理",
      ads: "滑动广告",
      navs: "首页导航",
      popups: "跳出广告",
      splash: "首屏广告",
      homeAd: "首页广告",
      homeProductGroups: "首页商品分组",
      userCenterAd: "用户中心广告",
      becomeAgentAd: "分销商中心广告",
      mini: "小程序",
      miniSetting: "小程序配置",
      merchantSetting: "商家信息配置",
      wechatMerchantApplymentInfo: "微信支付平台设置情况",
      serviceArea: "服务区",
      serviceAreaSetting: "服务区管理",
      review: "评价管理",
      reviewList: "评价列表",
      finance: "财务管理",
      financeHome: "对账首页",
      financeCheck: "账单对账",
      financeAccount: "账户管理",
      financeDownload: "下载专区",
      promotion: "营销活动",
      promotionShop: "店铺活动",
      proxy: "代理管理",
      proxyList: "代理列表",
      agentRecommenderList: "推荐关系",
      agentLevel: "代理等级",
      agentLevelProduct: "代理等级产品",
      commissionList: "佣金列表",
      withdrawList: "提现记录",
      withdrawRequestList: "提现申请记录",
      withdrawCommissionList: "相关佣金列表",
      sendMoney: "打款记录",
      specialShareList: "特殊服务费",
      transferAccountList: "转账账户",
      wechatRedPacketTopup: "红包充值记录",
      balanceVipOrders: "VIP购买订单",
      users: "用户管理",
      usersList: "用户列表",
      storeMemberships: "门店认证审核",
      storeMembershipAttribution: "客户归属统计",
      balance: "余额记录",
      topup: "充值记录",
      spend: "消费记录",
      reduce: "调整记录",
      balanceUserList: "用户列表（余额列表）",
      shows: "达人秀",
      showsList: "列表",
      setting: "系统设置",
      settingShop: "店铺设置",
      merchantStaff: "员工管理",
      selectLang: "选择语言",
      live: "直播管理",
      liveList: "直播列表",
      lottery: "抽奖管理",
      lotteryList: "抽奖列表",
      lotteryTheme: "抽奖样板",
      redPacket: "红包管理",
      lotteryEdit: "编辑抽奖",
      article: "文章管理",
      articleList: "文章列表",
      articleTags: "标签管理",
      articleEditorsChoice: "今日词条",
      manageWeapp: "小程序管理",
      members: "会员制度",
      membersList: "会员列表",
      membersCard: "会员卡",
      membersOrder: "会员订单",
      membersGiftCodes: "礼品码活动",
      taskCenter: "任务中心",
      media: "文件管理",
      mediaList: "文件列表",
      storageSetting: "存储设置",
      tuangouShop: "自提店",
      adminSection: "管理后台",
      orderDebug: "订单调试",
      profitSharingReconciliation: "分账待结算排查",
      weapp: "小程序管理",
    },
    userMenu: {
      loginMobile: "登录手机号",
      ownerMobile: "商家账号手机号",
      endDate: "服务到期日期",
      logout: "退出",
    },
    statusMenu: {
      business: "营业",
      noBusiness: "打烊",
      statusBusiness: "正在营业",
      statusNoBusiness: "已打烊",
    },
    search: "搜索订单",
    searchHint: "请输入订单号、订单序号、手机号",
    alreadyInBusiness: "店铺已经是营业状态，不需要更新",
    alreadyNoBusiness: "店铺已经是打烊状态，不需要更新",
    updatingBusinessStatus: "正在更新店铺状态...",
    updateBusinessStatusSuccess: "成功更新店铺状态",
    noPermission: "抱歉、您无权访问此功能模块",
  },
  order: {
    eat: "堂食",
    take: "外带",
    print: "打印订单",
    new: "新订单提醒",
    newDesc: "您有新的订单请及时处理",
    printView: {
      price: "单价",
      total: "合计",
      amount: "数量",
    },
    printTemplate: {
      search: "搜索模板...",
      create: "新建模板",
      createA4: "新建 A4 模板",
      create80: "新建 80mm 模板",
      desktopNewPrint: "电脑端新版打印",
      mobileNewPrint: "移动端新版打印",
      salesOrderTemplates: "销售单模板",
      usingNewBoth: "电脑端和移动端均使用新版打印",
      manageHint: "管理订单打印版式，设计后可在订单列表中使用",
      templatesUnit: "个模板",
      updated: "最近更新",
      copies: "份",
      desktopDefault: "电脑默认",
      settings: "设置",
      design: "设计",
      copy: "复制",
      delete: "删除",
      desktopEnabled: "电脑启用",
      mobileEnabled: "移动启用",
      setDesktopDefault: "设为电脑默认",
      deleteConfirm: "确定删除该模板？",
      deleted: "模板已删除",
      duplicated: "模板已复制",
      a4Custom: "A4 自定义模板",
      mmBasic: "%{size} 基础模板",
      defaultA4Name: "销售单 A4 模板",
      default80Name: "销售单 80mm 模板",
      salesOrder: "销售单",
      insertComponents: "插入组件",
      outline: "组件大纲",
      rowContainer: "行容器",
      itemsUnit: "项",
      sideStack: "旁侧堆叠",
      besideRows: "旁侧行数",
      besideRowsHint: "旁侧可排几行。侧栏内部也是 12 列：店铺名+标题各占 6 可同一行，客户+电话同理。拖边缘只改当前组件宽度。",
      ejectFromBeside: "移出旁侧",
      ejectFromBesideHint: "也可拖到二维码组外的其它组件上，或点组件右上角出口按钮。",
      joinBeside: "放回旁侧",
      dragToReorder: "拖动排序",
      moveUp: "上移",
      moveDown: "下移",
      props: "属性设置",
      selectComponent: "请选择一个组件",
      positionSize: "位置与大小",
      startCol: "起始列",
      span: "占列数",
      marginTop: "行上间距",
      textContent: "文本内容",
      showLabel: "显示标签",
      labelText: "标签文字",
      fontSize: "字号",
      bold: "加粗",
      align: "对齐",
      alignLeft: "左对齐",
      alignCenter: "居中",
      alignRight: "右对齐",
      templateLang: "模板语言",
      chooseTemplate: "选择模板",
      langZh: "中文",
      langUg: "维吾尔文",
      tableType: "表格类型",
      showHeader: "显示表头",
      tableBorder: "表格边框",
      borderNone: "无边框",
      borderFull: "全边框",
      summaryRow: "合计行",
      showSummary: "显示合计行",
      summaryLabel: "合计标签",
      summaryColumns: "合计列",
      headerRow: "表头行",
      bodyRow: "内容行",
      columnConfig: "列配置",
      addColumn: "添加列",
      imageUrl: "图片地址",
      height: "高度",
      customValue: "自定义内容",
      qrSize: "二维码尺寸",
      barcodeFormat: "条码类型",
      barcodeFormatQr: "二维码（微信可扫）",
      barcodeFormatCode128: "一维码 Code128",
      preview: "预览",
      save: "保存",
      saved: "模板已保存",
      exit: "退出",
      exitConfirm: "退出设计器？未保存的更改将丢失。",
      notFound: "模板不存在",
      backToList: "返回列表",
      emptyCanvas: "从左侧插入组件开始设计",
      groups: {
        text: "文本",
        qrcode: "二维码",
        image: "图片",
        barcode: "条码",
        products: "商品明细",
        other: "其他",
      },
      comps: {
        customText: "自定义文本",
        customerName: "客户名称",
        orderNotes: "单据备注",
        merchantName: "店铺名称",
        merchantTel: "店铺电话",
        orderTime: "下单时间",
        printTime: "打印时间",
        orderNo: "单据编号",
        address: "客户地址",
        customerTel: "客户手机号",
        payType: "支付方式",
        shipPrice: "运费",
        totalAmount: "合计金额",
        orderQr: "订单小程序码",
        customQr: "自定义二维码",
        logo: "公司logo",
        customImage: "自定义图片",
        orderBarcode: "单号条码",
        customBarcode: "自定义条码",
        productLines: "单品明细",
        productSummary: "按商品汇总明细",
        divider: "分割线",
        spacer: "空白间距",
      },
      cols: {
        index: "序号",
        image: "商品图片",
        name: "商品名称",
        sku: "规格",
        nameSku: "商品/规格",
        barcode: "条码",
        unit: "单位",
        amount: "数量",
        price: "单价",
        lineTotal: "金额",
        remark: "备注",
      },
    },
    isFromBB: "来自布鲁街",
    isDouyin: "抖音订单",
    payTypes: {
      all: "全部",
      wechat: "微信支付",
      cash: "货到付款",
      balance: "余额付款",
    },
    orderTypes: {
      all: "全部",
      valid: "有效",
      invalid: "无效",
      unsend: "未发货",
      waiting: "待处理",
      sent: "已发货",
      delivered: "已送达",
      completed: "已签收",
      applied: "已申请",
    },
    refundTypes: {
      all: "全部",
      inProgress: "进行中",
      waiting: "待处理",
      accepted: "已审核",
      refunding: "正在退款",
      refunded: "已退款",
      refused: "已拒绝",
      failed: "已失败",
    },
    sortTypes: {
      created_at_desc: "下单时间（降序）",
      created_at_asc: "下单时间（升序）",
      sequence: "订单序号",
    },
    loadingData: "正在加载订单列表...",
    printingOrder: "正在打印订单...",
    updatingData: "正在更新订单列表...",
    payTypesTitle: "支付类型",
    orderTypesTitle: "订单状态",
    finishProfitSharing: "完结订单",
    sortTypesTitle: "订单排序",
    rangeTimeTitle: "选择时间",
    ordersTitleCount: "总共 %{total} 个订单",
    ordersTitle: "订单列表",
    loadingOrder: "正在读取订单列表...",
    loadingOrderEmpty: "暂无相关订单数据",
    todaysTitle: "订单概况",
    detailStatisticsTitle: "产品概况",
    todaysLoading: "正在读取数据...",
    todaysEmpty: "暂无数据",
    todaysCount: "订单：%{orderCount} 笔",
    productCount: " %{productCount} 个 ",
    productAmount: " %{productAmount} 元 ",
    todaysTotal: "总额：%{totalPrice} 元",
    productInfo: "商品信息",
    productInfoCollapse: "收起",
    productInfoExpand: "展开",
    note: "用户备注：",
    noteUser: "[用户要求] %{note}；",
    noteNo: "无特殊要求",
    tablewareCount: "[餐具数量] %{count}；",
    tablewareNo: "自备",
    tablewarePeople: "%{count}人",
    packingFee: "包装费",
    giftLabel: "赠品:",
    shippingFee: "配送费",
    subTotal: "小计",
    merchantExpence: "商家活动支出",
    merchantExpenceDisocunt: "商家折扣总%{price}元",
    merchantExpenceCoupon: "商家优惠券总%{price}元",
    platformExpence: "平台活动支出",
    platformExpenceDisocunt: "平台折扣总%{price}元",
    platformExpenceCoupon: "平台优惠券总%{price}元",
    platformIncome: "平台服务费",
    paymentFee: "微信支付手续费",
    platformRate: "平台服务费为%{rate}%",
    merchantIncome: "本单预计收入",
    refundLog: "退款记录",
    refundQuantity: "退{{count}}",
    userPayed: "用户实际支付金额:",
    userPayedProductFee: "用户支付产品金额:",
    userPayedShipPriceFee: "用户支付配送费:",
    statusPayed: "(已支付)",
    orderTime: "下单时间：",
    orderNo: "订单编号：",
    jdOrderNo: "京东订单编号：",
    bbOrderNo: "订单ID：",
    orderShipNo: "快递单号：",
    copyShipNo: "复制快递单号",
    copyShipNoSuccess: "复制成功",
    copyShipNoFailed: "复制失败",
    accept: "接受订单",
    acceptHint: "是否确定接受此订单？",
    accepting: "正在接受订单...",
    cancel: "取消订单",
    cancelHint: "是否确定取消此订单？",
    canceling: "正在取消订单...",
    send: "快递发货",
    prepared: "备餐完成",
    delivered: "已送达",
    sendTitle: "订单发货",
    reject: "拒绝",
    discountTitle: "产品折扣促销",
    sendTrackName: "快递名称",
    sendTrackDate: "快递发货时间",
    sendTrackReciet: "快递运单凭证",
    sendTrackNameHint: "请选择快递名称",
    sendTrackReason: "备注",
    sendTrackNumber: "快递单号",
    sendTrackNumberHint: "请输入快递单号",
    sendShipWeight: "快递重量",
    sendShipWeightUnit: "千克",
    sendShipWeightHint: "请输入快递重量",
    sendShipPrice: "运输费用",
    sendShipReceipt: "运单票据",
    sendShipPriceUnit: "元",
    sendShipPriceHint: "请输入运输费用",
    sending: "正在进行发货...",
    sendChange: "修改快递",
    sendChangeTitle: "修改订单快递",
    sendChanging: "正在修改订单快递...",
    user: "下单用户：(%{user})",
    kuaidi100Title: "快递查询",
    addForm: "添加",
    deleteForm: "删除",
    importErrorCheck: "查看错误原因",
    calculate: "佣金计算",
    parentCommission: "父代佣金%{price}元",
    childCommission: "代理佣金%{price}元",
    refund: "退款",
    refundCount: "退款数量",
    refundAmount: "已退数量%{amount}个",
    refundPrice: "已退金额%{price}元",
    refundMax: "至多能退%{max}个",
    refundConfirm: "确认退款吗？",
    atLeastRefund: "至少选择一个退款的商品",
    refundReasonWarning: "退款原因不能为空",
    refundReason: "请填写退款原因",
    refundCheck: "查询退款情况",
    refundAccept: "审核退款",
    refundReject: "拒绝退款",
    refundAcceptAfterReject: "拒收后退款",
    refundAcceptAfterReturn: "退货后退款",
    refundAmount: "申请退款金额",

    status: "订单状态",
  },
  shows: {
    type: {
      all: "全部",
      text: "文字",
      image: "图片",
      video: "视频",
      audio: "音频",
    },
    status: {
      all: "全部",
      valid: "审核通过",
      invalid: "未通过",
      draft: "未提交",
      rejected: "已拒绝",
      active: "启用",
      inactive: "禁用",
    },
    sortTypes: {
      created_at_desc: "上传时间（降序）",
      created_at_asc: "上传时间（升序）",
    },
    noTags: "未设置标签",
    mediaTypesTitle: "媒体",
    orderTypesTitle: "状态",
    sortTypesTitle: "排序",
    showsTitle: "秀列表",
    loadingShow: "正在读取秀列表...",
    loadingShowEmpty: "暂无秀",
    showsTitleCount: "总共 %{total} 个秀",
    deleteConfirm: "真要删除此秀？",
    categories: "分类",
    add: "添加新秀",
  },
  showsEdit: {
    videoCover: "封面",
    headerTitle: "新建秀",
    headerTitleEdit: "编辑秀",
    creatingShowSuccess: "成功创建秀",
    updatingProductSuccess: "成功更新秀",
    catLabel: "分类",
    nameLabel: "内容",
    nameHint: "请填写你要输入的内容",
    nameRequired: "内容不能为空",
    imagesLabel: "图片",
    tagLabel: "商品标签",
    tagHint: "请选择商品标签",
    selectProduct: "请选择商品",
    selectCoupon: "请选择优惠券",
    bindProduct: "绑定商品",
    statusLabel: "媒体",
    languageLabel: "语言",
    productLabel: "标签",
    status: {
      image: "图片",
      video: "视频",
      text: "文字",
    },
    orderLabel: "顺序",
    addTag: "添加标签",
    orderIdLabel: "订单号",
  },
  product: {
    filter: {
      all: "全部",
      onShelf: "售卖中",
      offShelf: "已下架",
      discounted: "特价产品",
      order_desc: "利润降序",
      order_asc: "利润升序",
      price_start: "最低价",
      price_end: "最高价",
      quantity_desc: "库存降序",
      quantity_asc: "库存升序",
      createdAtRange: "创建时间",
    },
    stats: {
      newProducts: "新增商品",
      onShelfCount: "售卖中",
      offShelfCount: "已下架",
    },
    search: {
      product_no: "商品编码",
      barcode: "条形码",
      name: "商品名称",
    },
    discount: {
      title: "产品促销",
      priceLabel: "促销价",
      discountedPriceHint: "请输入促销价",
      discounting: "正在进行打折...",
    },
    loadingCatsData: "正在加载商品分类数据...",
    loadingProductsData: "正在加载商品列表数据...",
    headerCreate: "新建商品",
    headerSeatchHint: "请输入",
    catsTitle: "分类列表",
    catsManage: "管理分类",
    catsLoading: "加载分类数据...",
    catsNull: "暂无分类数据",
    catsEmpty: "尚未添加分类",
    selectAll: "全选本页",
    batchOnShelf: "批量上架",
    batchOffShelf: "批量下架",
    batchFreeShipping: "批量包邮",
    batchCancelFreeShipping: "取消包邮",
    batchDelete: "批量删除",
    productsEmpty: "暂无相关的商品数据",
    catsModalTitle: "分类管理",
    catsModalOkText: "确定",
    catsModalCancelText: "取消",
    catsModalAvailable: "可选分类",
    catsModalSelected: "本店分类",
    catsModalAdd: "添加",
    catsModalRemove: "移除",
    catsModalInclude: " (含有%{count}个商品)",
    catsModalIncludeWarning: "不能移除含有商品的分类",
    updatingProduct: "正在更新商品数据...",
    updatingProductSuccess: "成功更新商品数据，正在刷新列表...",
    priceRangeAlert: "最低价大于最高价",
    productItem: {
      offShelf: "已下架",
      monthySale: "月销 %{count}",
      likes: "赞 %{count}",
      quantity: "库存",
      quantityLimitless: "无限",
      quantityZero: "缺货",
      actionUp: "上架",
      actionDown: "下架",
      actionConfirm: "确定",
      actionDelete: "删除",
      actionEdit: "编辑",
      actionCancel: "取消",
      oneKeyCopy: "获取直播链接",
      skuImage: "/assets/images/product-item-sku.png",
      actionClone: "复制",
      actionQrcode: "二维码",
    },
    qrcode: {
      title: "商品二维码",
      generating: "正在生成二维码...",
      generateError: "二维码生成失败",
    },
    cats: {
      actions: "操作",
      addChild: "添加子分类",
      edit: "编辑此分类",
      delete: "删除此分类",
      search: "请输入您想搜索的分类名称",
      add: "添加新分类",
      deleteWarning: "确定删除此分类吗？",
      catWarning: "该店铺还没添加任何分类，不能新建商品",
      catEditWarning: "该店铺还没添加任何分类，不能新建商品",
      zhName: "分类名称（中文）",
      ugName: "分类名称（维语）",
      name: "分类名称",
      save: "保存",
      cancel: "取消",
    },
  },
  productEdit: {
    status: {
      onShelf: "上架",
      offShelf: "下架",
    },
    suggest: {
      on: "推荐",
      off: "不推荐",
    },
    headerTitle: "新建商品",
    headerTitleEdit: "编辑商品",
    video: "视频",
    headerBack: "返回",
    catLabel: "商品分类",
    catRequired: "商品分类不能为空",
    nameLabel: "商品名称(中文)",
    nameHint: "请输入商品中文名称",
    numberLabel: "商品编码",
    numberHint: "请输入商品编码",
    numberRequired: "商品编码不能为空",
    valid_date: "保质期",
    validHint: "请输入保质期",
    manufactured_date: "生产日期",
    recommended_price: "建议零售价",
    recommendedHint: "请输入建议零售价",
    basic_sales: "基础销量",
    basicHint: "请输入基础销量",
    barcodeLabel: "条形码",
    barcodeHint: "请输入条形码",
    baseUnitBarcodeLabel: "条形码（基础单位）",
    baseUnitBarcodeHint: "请输入基础单位条形码",
    packUnitBarcodeLabel: "条形码（包装单位）",
    packUnitBarcodeHint: "请输入包装单位条形码",
    nameRequired: "商品中文名称不能为空",
    nameUgLabel: "商品名称(维文)",
    nameUgHint: "请输入商品维文名称",
    imagesLabel: "商品图片",
    zhImagesLabel: "四宫格图片（汉语）",
    ugImagesLabel: "四宫格图片（维语）",
    imagesUpload: "添加",
    aspectRatioTip: "建议比例: {ratio}",
    cropImage: "裁剪图片",
    zoom: "缩放",
    uploadError: "上传失败",
    selectFromLibrary: "或从媒体库选择",
    imagesRequired: "请确保至少有一张商品图片",
    detailLabel: "商品详情",
    detailImagesLabel: "详情图片",
    detailImagesHint: "上传并拖拽调整顺序，详情页将按此顺序展示图片",
    detailImagesEmpty: "暂无详情图片，请从下方上传或从媒体库选择",
    descLabel: "商品详情(中文)",
    descHint: "请输入商品中文描述，限400字",
    descUgLabel: "商品详情(维文)",
    detailDescLabel: "商品详情描述(中文)",
    detailDescLabelHint: "请输入该商品盒/袋/箱信息",
    detailUgDescLabelHint: "请输入该商品盒/袋/箱信息 (维文)",
    detailDescUgLabel: "商品详情描述(维文)",
    descUgHint: "请输入商品维文描述，限400字",
    standardLabel: "商品价格：",
    propertyLabel: "商品规格",
    multiSpecProduct: "多规格商品",
    multiSpecProductHint: "开启后可设置规格及每个规格的价格库存",
    multiSpecPriceHint: "请在「商品规格」页设置各规格的价格和库存",
    multiSpecPriceRange: "售价区间",
    inPriceLabel: "进货价格：",
    inPriceLabelShort: "进：",
    outPriceLabel: "销售价格：",
    outPriceLabelShort: "售：",
    commission: "佣金",
    parentCommission: "父佣金",
    quantityLabel: "库存数量：",
    packPriceLabel: "包装价格：",
    packCountLabel: "包装数量：",
    baseUnitLabel: "基础单位：",
    packUnitLabel: "包装单位：",
    packSizeLabel: "1包装含基础单位数：",
    packUnitHint: "例如：1 × 箱 = 15 瓶",
    hasPackUnit: "启用包装单位",
    packUnitPriceLabel: "包装单位售价：",
    selectUnit: "请选择单位",
    manageUnitsHint: "请先在「单位管理」中添加单位",
    baseUnitRequired: "请先选择基础单位",
    standardRequired: "不能为空",
    statusLabel: "商品状态：",
    orderLabel: "商品顺序",
    suggestLabel: "是否推荐商品",
    skuImage: "/assets/images/product-edit-sku.png",
    saveAndBack: "保存并返回",
    save: "保存",
    saveAndContinue: "保存并继续创建",
    cancel: "取消",
    skuWarning: "平台商品不能编辑图片",
    creatingProduct: "正在创建商品...",
    creatingProductSuccess: "成功创建商品",
    updatingProduct: "正在更新商品...",
    updatingProductSuccess: "成功更新商品",
    uploadingImages: "正在上传图片...",
    uploadImageTypeWarning: "图片格式必须是 .jpg/.jpeg/.png ！",
    uploadImageSizeWarning: "图片大小不能超过1MB ！",
    uploadNavImageSizeWarning: "图片大小不能超过1MB ！",
    uploadVideoSizeWarning: "视频大小不能超过3MB ！",
    delete: "确认删除此商品吗？",
    translate: "翻译",
    refetchImgs: "更新图片",
    refetchDesc: "更新详情",
    restorePrice: "恢复原价",
    priceDiscount: "产品打折",
    basicInfo: "基本信息",
    priceInfo: "价格信息",
    otherInfo: "其他信息",
    commissionInfo: "佣金信息",
    shipPriceLabel: "运费: ",
    maxBuyLimitLabel: "最大限购数量",
    minBuyLimitLabel: "最小限购数量",
    isFreeShipping: "是否免运费",
    isAgentLevelProduct: "是否代理等级产品",
    freeShipping: "包邮",
    notFreeShipping: "不包邮",
    imagesZhLabel: "中文标签图",
    imagesUgLabel: "维文标签图",
    douyinOrder: "抖音下单",
  },
  review: {
    status: {
      all: "全部",
      reviewed: "已回复",
      unReviewed: "未回复",
    },
    satisfaction: {
      all: "全部",
      best: "好评",
      normal: "中评",
      worst: "差评",
    },
    content: {
      all: "全部",
      noContent: "有内容",
    },
    loadingData: "正在读取评价列表数据...",
    loadingDataEpmty: "暂无数据",
    updatingData: "正在更新评价列表数据...",
    headerTitle: "最近30天评价统计：",
    headerMerchant: "商家评分",
    headerClient: "客户满意度",
    filterStatus: "评价状态",
    filterSatisfaction: "满意程度",
    filterContent: "有无内容",
    filterDate: "选择时间",
    listTitle: "符合条件的评价: %{count}条",
    replyValidWarning: "请输入回复内容",
    replyLengthWarning: "回复内容不能超过300字",
    replyCommitting: "正在提交回复",
    replyCommittingSuccess: "回复成功, 正在更新数据...",
    reviewItem: {
      score5: "很棒",
      score4: "很好",
      score3: "可以",
      score2: "偏差",
      score1: "很差",
      merchantScore: "商家评分%{score}星：%{scoreText}",
      merchantText: "商家",
      deliveryText: "配送",
      ovewrallText: "总体",
      overallOk: "满意",
      overallNotOk: "不满意",
      noContent: "无内容",
      noImage: "无图片",
      replyText: "回复：",
      noReply: "无回复",
      actionReply: "回复",
      replyHint: "险300字，请勿恶意回复，若被发现将严重处理",
      replyConfirm: "确定",
      replyCancel: "取消",
      detailLabel: "订单详情",
    },
  },
  financeHome: {
    loadingData: "正在加载结算数据...",
    loadingEmpty: "暂无数据",
    headerTitle: "账单信息",
    headerAllBills: "全部账单",
    listTitle: "已结算账单",
    listTitleUnsettled: "待结算账单",
    listHeaderDate: "日期",
    listHeaderSum: "账单金额",
    listHeaderActions: "操作",
    listHeaderDetails: "账单信息",
    listItemActionDetails: "查看",
    listItemActionDownload: "下载",
    listGroupTime: "%{start_date}至%{end_date}的账单",
    listGroupInfo: "已汇入余额>",
    listGroupInfoUnsettled: "预计%{sign_date}前入账",
  },
  financeCheck: {
    selectTime: "选择时间",
    allTime: "所有时间",
    loadingSettledData: "正在获取已结算账单信息...",
    loadingUnsettledData: "正在获取待结算账单信息...",
  },
  financeAccount: {
    times: {
      month: "近一月",
      season: "近一季",
      custom: "自定义",
    },
    settlementTypes: {
      cycle: "周期结算",
    },
    loadingData: "正在加载结算账户数据...",
    loadingEmpty: "暂无数据",
    ballanceInfoTitle: "结算信息",
    ballanceInfoCycle: "结算周期",
    ballanceInfoCycleValue: "%{day}天周期结算",
    ballanceInfoCycleType: "结算方式",
    ballanceInfoMin: "最低结算金额",
    ballanceInfoValue: "%{amount}元",
    ballanceInfoContact: "商家财务联系人",
    ballanceInfoContactPhone: "联系人电话",
    bankInfoTitle: "银行卡信息",
    bankInfoType: "账户类型",
    bankInfoName: "开户银行(简称)",
    bankInfoNameFull: "开户银行(全称)",
    bankInfoBankTypeCompany: "对公",
    bankInfoBankTypePrivate: "对私",
    bankInfoAddressCode: "省市区编号",
    bankInfoBranchId: "联行号",
    bankInfoAccount: "银行卡卡号",
    bankInfoAccountName: "银行卡户名",
    bankCardImage: "银行卡照片（OCR自动识别卡号）",
    bankProvince: "开户省份",
    bankCity: "开户城市",
    selectBank: "选择开户银行",
    searchBank: "搜索银行名称",
    selectBranch: "选择开户支行",
    loadingBranches: "正在加载支行列表…",
    bankBranchHint: "选择支行后自动填入联行号与开户行全称；若无支行列表可手动填写联行号",
    bankAddressCodeHint:
      "一般为6位地区编码；选择城市后会预填微信城市码，请按进件要求核对《省市区编号对照表》",
    ocrRunning: "正在识别证照信息…",
    ocrFilled: "已根据识别结果自动填写",
    ocrFailed: "识别失败，请手动填写",
    organizationType: "主体类型",
    organizationTypeMicro: "小微商户",
    organizationTypePersonal: "个人卖家",
    organizationTypeIndividual: "个体商户",
    organizationTypeEnterprise: "企业",
    organizationTypeGovernment: "党政",
    organizationTypeOther: "其他组织",
    contactType: "联系人类型",
    contactTypeLegal: "经营者/法人",
    contactTypePersonInCharge: "负责人",
    agentInfoHint:
      "负责人将作为微信支付超级管理员完成签约。请在银行信息页填写负责人联系电话。",
    agentFullName: "负责人姓名",
    agentIdNumber: "负责人身份证号码",
    agentIdCardFront: "负责人身份证人像面",
    agentIdCardBack: "负责人身份证国徽面",
    agentIdStartDate: "负责人证件生效日期",
    agentIdEndDate: "负责人证件失效日期",
    agentIdLongTerm: "负责人证件长期有效",
    agentContactPhoneHint: "负责人联系电话（用于签约及验证码）",
    contact_email: "邮箱",
    listTitle: "账单流水记录",
    listFilterTime: "选择时间",
    listHeaderDate: "日期",
    listHeaderName: "账单名称",
    listHeaderAmount: "金额",
    listHeaderStatus: "状态",
    listHeaderAction: "操作",
    listItemName: "%{start_date}至%{end_date}的账单",
    checkoutDateLabel: "%{checkout_date}日账单",
    listItemAmount: "%{amount}元",
    listItemStatusSuccess: "交易成功",
    listItemActionDetails: "详情",
    basicInfo: "商家信息",
    merchantAccountInfo: "商家银行信息",
    merchantInfo: "商家主体信息",
    licences: "证件",
    licenceNumber: "证件注册号",
    licenceName: "商户名称",
    licenceImage: "证件扫描件",
    licenceLegal: "法人",
    licenceIdCardFront: "身份证人像面",
    licenceIdCardBack: "身份证国徽面",
    licenceIdName: "身份证姓名",
    licenceIdNumber: "身份证号码",
    licenceIdStartDate: "身份证有效期开始日期",
    licenceIdEndDate: "身份证有效期结束日期",
    merchantAbbr: "商家简称",
    customerNumber: "售后电话",
    licenceIdAddress: "身份证地址",
    idLongTerm: "长期",
    logo: "店铺logo",
  },
  financeDownload: {
    tabs: {
      generate: "选择账单日期",
      history: "生成账单历史",
    },
    times: {
      month: "近一天",
      season: "近七天",
      custom: "自定义",
    },
    loadingData: "正在获取账单列表...",
    loadingEmpty: "暂无数据",
    generateFilterTime: "选择时间",
    generateActionGenerate: "生成账单",
    historyHeaderNo: "序号",
    historyHeaderName: "文件名",
    historyHeaderStatus: "状态",
    historyHeaderActions: "操作",
    listItemName: "%{start_date}至%{end_date}的账单",
    checkoutDateLabel: "%{checkout_date}账单",
    historyItemStatusSuccess: "生成成功",
    historyItemStatusGenerating: "正在生成...",
    historyItemStatusFailed: "生成失败",
    historyItemActionDownload: "下载",
    historyItemActionDelete: "删除",
    historyItemActionDeleteWarning: "确认要删除此帐单吗？",
    historyItemActionDeleteWarningOk: "是的",
    historyItemActionDeleteWarningCancel: "取消",
    generating: "正在生成账单...",
    generatingWarning: "正在生成账单，请稍后操作！",
    deleting: "正在删除账单...",
    generateSuccess: "账单已提交，正在更新列表数据...",
    updatingList: "正在更新列表数...",
    deleteSuccess: "账单已成功删除，正在更新列表数据...",
    range: "日期差距最多为15天，已为你调整",
  },
  orderDownload: {
    tabs: {
      generate: "选择订单日期",
      history: "导出历史",
    },
    generateActionGenerate: "导出订单列表",
    range: "日期差距最多为两天，已为你调整",
    date: "日期",
    orderCount: "订单数",
  },

  financeBillDetail: {
    loadingData: "正在加载账单详情...",
    loadingEmpty: "暂无数据",
    headerBack: "返回",
    headerTitle: "结算账单详情",
    billAmount: "收入金额",
    billAmountValue: "%{amount}元",
    billAccount: "汇入账号",
    billType: "类型",
    billTime: "打款时间",
  },
  financeCheckDaily: {
    tabs: {
      order: {
        name: "订单类",
        tabs: {
          all: "全部",
          normal: "外卖订单",
          refund: "退款订单",
        },
      },
      other: {
        name: "订单类",
        tabs: {
          all: "全部",
          ship_fee: "配送费用",
          bad_food: "餐损赔付",
          serve_return: "服务费返还",
          part_refund: "部分退款",
          refund_neutralize: "部分退款冲抵",
        },
      },
    },
    loadingData: "正在加载日账单详情...",
    loadingEmpty: "暂无数据",
    headerBack: "返回",
    headerDate: "%{date} 日账单",
    headerInfo: "已汇入余额",
    headerInfoUnsettled: "预计%{sign_date}入账",
    listUnit: "单位：元",
    listHeaderOrderDate: "日期&订单编号",
    listHeaderOrderType: "类型",
    listHeaderOrderPrice: "商品原价",
    listHeaderOrderPacking: "包装费用",
    listHeaderOrderEvent: "商家活动支出",
    listHeaderOrderPlatform: "平台服务费",
    listHeaderOrderShip: "配送费",
    listHeaderOrderDonate: "公益捐款",
    listHeaderOrderTotal: "结算金额",
    listHeaderOrderAction: "操作",
    listHeaderOtherDate: "日期",
    listHeaderOtherType: "类型",
    listHeaderOtherDetails: "详细类型",
    listHeaderOtherTotal: "结算金额",
    listHeaderOtherAction: "操作",
    listItemActionDetail: "详情",
    listFooterTotal: "总计 (共%{order_count}笔)",
  },
  financeOrderDetail: {
    headerBack: "返回",
    headerTitle: "订单详情",
    detailProducts: "商品",
    detailMerchant: "商家活动",
    detailPaymentFee: "支付手续费",
    detailPlatform: "平台抽成",
    detailShip: "配送费用",
    detailDonation: "公益捐款",
    detailTotal: "已结算金额",
    footerSequence: "订单序号：#%{sequence}",
    footerNo: "订单编号：#%{no}",
    footerTime: "下单时间：#%{time}",
    footerTimeFinish: "完成时间：#%{time}",
  },
  proxy: {
    loadingData: "正在读取代理列表数据...",
    updatingData: "正在更新代理列表数据...",
    searchFromParent: "搜索父代",
    filterMobile: "手机号码",
    filterMobileHint: "请输入代理手机号或昵称",
    filterLevel: "代理等级",
    filterOwner: "有无代理",
    filterStatus: "审核状态",
    addProxy: "添加代理",
    listTitle: "符合条件的代理：%{count}个",
    listItemLevel: "等级",
    listItemMobile: "手机",
    listItemPercent: "优惠",
    listItemParent: "父代",
    listItemParentNone: "无",
    listItemEdit: "编辑",
    listItemDelete: "删除",
    viewItems: "查看物品",
    listNoData: "暂无数据",
    deleteHint: "是否要删除该代理？",
    deleting: "正在删除代理...",
    updating: "正在更新代理...",
    adding: "正在添加代理...",
    editMobile: "代理手机",
    editMobileHint: "请输入代理手机号",
    editMobileLength: "请输入11位的手机号",
    editLevel: "代理等级",
    editLevelHint: "请选择代理等级",
    editPercent: "代理优惠",
    editProxySwitch: "可否招代理",
    editParentMobile: "父级手机",
    editParentMobileHint: "请输入父级代理手机号",
    editParantPercent: "父级分成",
    editTitle: "添加代理",
    editTitleEdit: "编辑代理",
    editOk: "确定",
    editCancel: "取消",
    all: "全部",
    owner: "有代理",
    notOwner: "无代理",
    reviewing: "审核中",
    reviewed: "已审核",
    editProxyStatusSwitch: "审核通过",
    editIsPartnerSwitch: "是否合伙人",
    editIsShopOwnerSwitch: "是否店长",
    registerDate: "申请时间",
    listProxyTeam: "团队数量",
    listProxyClient: "客户数量",
    listProxyOrders: "订单数量",
    apply: "代理申请页面",
    recommenderList: {
      title: "推荐关系",
      merchant: "商家",
      merchantFilter: "商家",
      merchantPlaceholder: "选择或搜索商家",
      recommenderFilter: "推荐人",
      recommenderHint: "推荐人手机号或昵称",
      recommender: "推荐人",
      invitee: "被邀请人",
      agentFilter: "代理人",
      agent: "代理人",
      teamCount: "团队人数",
      createdAt: "绑定时间",
      expireDate: "过期时间",
      statusRegistered: "已注册",
      statusNotRegistered: "未注册",
      statusExpired: "已过期",
      reset: "重置",
    },
  },
  commissionList: {
    mobile: "手机号",
    order_no: "订单号",
    original: "订单原价",
    price: "订单金额",
    ship: "运费",
    real: "实付款",
    receiver: "收货人",
    tel: "收货人手机号",
    address: "收货地址",
    comm: "佣金",
    channel: "渠道",
    status: "状态",
    payoutMethod: "发放方式",
    order_id: "订单ID",
    unfreeze: "解冻",
    confirmFinished: "确认完成",
    update: "更新物流",
    confirmReceived: "确认送达",
    confirmSend: "确认发货",
    confirm: "审核",
    reject: "拒绝",
    appliedAmount: "申请提现佣金",
    appliedDate: "申请时间：%{date}",
    sendWarehouse: "发给仓库",
    shareableRealPayment: "实付款：%{amount}",
    shareableLimit: "可分账上限（%{ratio}%）：%{amount}",
    shareableOrderTotal: "订单佣金合计：%{amount}",
    shareableExcess: "超出：%{amount}",
    paidOtherWayAction: "其他方式打款",
    paidOtherWayTitle: "其他方式打款",
    paidOtherWayPayType: "打款方式",
    paidOtherWayPayTypePlaceholder: "如：银行转账、现金、支付宝",
    paidOtherWayPayTypeRequired: "请填写打款方式",
    paidOtherWayDate: "打款日期",
    paidOtherWayDateRequired: "请选择打款日期",
    paidOtherWayEvidence: "打款凭证",
    paidOtherWayEvidenceUpload: "上传凭证",
    paidOtherWaySubmit: "确认提交",
  },
  balanceVip: {
    orderNo: "订单号",
    user: "用户",
    amount: "购买金额",
    discount: "锁定折扣",
    paidAt: "支付时间",
    status: "状态",
    action: "操作",
    pendingAccept: "待接单",
    accepted: "已接单",
    searchPlaceholder: "订单号 / 手机号 / 昵称",
    refresh: "查询",
  },
  specialShareList: {
    tab: "转账记录",
    amount: "服务费金额",
    billNo: "转账单号",
    remark: "备注",
    failReason: "失败原因",
    sync: "同步状态",
    syncSuccess: "状态已更新",
    searchPlaceholder: "订单号 / 订单ID / 合作方手机号或昵称",
  },
  specialShareParties: {
    tab: "收款方设置",
    add: "添加收款方",
    addTitle: "添加特殊服务费收款方",
    editTitle: "编辑收款方",
    percent: "服务费比例 (%)",
    percentHint: "按订单实付金额计算，例如 10 表示 10%。所有收款方合计不能超过 30%。",
    percentRequired: "请输入服务费比例",
    displayName: "备注名称",
    displayNamePlaceholder: "可选，用于内部备注",
    mobileRequired: "请输入手机号",
    mobilePlaceholder: "用户注册手机号，须已绑定微信小程序",
    deleteConfirm: "确定删除该收款方？",
    selectUser: "收款用户",
    userRequired: "请选择收款用户",
    userId: "用户 ID",
    viewOnlyNotice: "仅超级管理员可添加或修改收款方，当前为查看模式。",
    totalPercent: "当前启用比例合计：{{total}}%",
    totalPercentWarning: "启用比例合计 {{total}}% 已超过微信 30% 分账上限，请调整",
  },
  transferAccountList: {
    add: "添加转账账户",
    refresh: "刷新",
    label: "账户名称",
    mchId: "微信商户号",
    usageToday: "今日已用 / 限额",
    transferCount: "今日笔数",
    purposes: "用途",
    purpose_commission: "代理佣金",
    purpose_special_share: "特殊服务费",
    priority: "优先级",
    status: "状态",
    default: "默认",
    enabled: "启用",
    disabled: "停用",
    unlimited: "不限",
    actions: "操作",
    edit: "编辑",
    delete: "删除",
    deleteConfirm: "确定删除该转账账户吗？",
    createTitle: "添加转账账户",
    editTitle: "编辑转账账户",
    saved: "保存成功",
    deleted: "删除成功",
    uploadFailed: "上传失败",
    labelRequired: "请填写账户名称",
    mchIdRequired: "请填写微信商户号",
    serialNo: "证书序列号",
    v3Key: "APIv3密钥",
    publicKeyId: "公钥ID",
    merchantKey: "商户密钥",
    dailyQuota: "日限额(元)",
    unlimitedHint: "留空表示不限",
    upload: "上传证书",
    apiCert: "API证书",
    apiKey: "API私钥",
    publicKey: "微信支付公钥",
  },
  wechatRedPacketTopup: {
    refresh: "刷新",
    amount: "充值金额",
    bookedAt: "记账时间",
    balance: "充值后余额",
    businessType: "业务类型",
    fundFlowNo: "资金流水单号",
    mchId: "商户号",
    syncHint: "充值记录从微信运营账户资金账单同步，一般次日上午可见。商户不能手工登记。",
    pausedHint: "红包发放因运营账户余额不足已暂停。系统每 5 分钟查询余额，足够支付待发红包后会自动解除。",
  },
  statisticsOverview: {
    title: "经营概览",
    noSections: "当前商户未开通可查看的统计模块",
    ordersTitle: "订单统计",
    productsTitle: "商品统计",
    commissionsTitle: "佣金统计",
    transfersTitle: "转账统计",
    todayOrders: "今日订单",
    yesterdayOrders: "昨日订单",
    monthOrders: "本月订单",
    todayIncome: "今日收入",
    todayTurnover: "今日成交额",
    monthIncome: "本月收入",
    orderUnit: "单",
    productTotal: "商品总数",
    productInSales: "在售商品",
    productStopSelling: "停售商品",
    commissionPending: "待结算笔数",
    commissionPendingAmount: "待结算金额",
    commissionProcessing: "处理中笔数",
    commissionPaidAmount: "已打款金额",
    commissionFrozen: "冻结笔数",
    commissionTodayAmount: "今日新增佣金",
    commissionMonthCount: "本月佣金笔数",
    commissionMonthAmount: "本月佣金金额",
    transferTodayCount: "今日转账笔数",
    transferTodayAmount: "今日转账金额",
    transferSuccessCount: "今日成功笔数",
    transferPendingCount: "今日待处理",
    transferFailedCount: "今日失败笔数",
    transferMonthCount: "本月转账笔数",
    transferMonthAmount: "本月成功金额",
    transferAccount: "转账账户",
    defaultAccount: "默认",
    disabled: "停用",
    mchId: "商户号",
    todayUsage: "今日已用",
    todayCount: "今日笔数",
    remainingQuota: "剩余额度",
    unlimited: "不限",
    chart: {
      week: "近7天",
      month: "近30天",
      season: "近90天",
    },
    commissionTodayCount: "今日新增笔数",
  },
  statisticsCommon: {
    preset7: "近7天",
    preset30: "近30天",
    preset90: "近90天",
    apply: "查询",
    trend: "趋势",
    periodCompare: "环比上期",
    previousPeriod: "上期",
    exportCsv: "导出 CSV",
    action: "操作",
    viewOrders: "查看订单",
    viewProducts: "查看商品",
    viewCommissions: "查看佣金",
    viewTransferAccounts: "管理转账账户",
  },
  statisticsOrders: {
    title: "订单统计",
    ordersCount: "订单数",
    turnover: "成交额",
    merchantIncome: "商家收入",
    avgOrder: "客单价",
    amount: "金额",
    paytype: "支付方式",
    paytypeBreakdown: "支付方式分布",
    statusGroups: {
      all: "全部状态",
      completed: "已完成",
      canceled: "已取消",
      refund: "退款相关",
    },
    paytypes: {
      all: "全部支付",
      wechat: "微信支付",
      balance: "余额支付",
      cash: "现金支付",
    },
  },
  statisticsProducts: {
    title: "商品统计",
    newProducts: "期间新增商品",
    newProductsTrend: "新增商品趋势",
    editedProducts: "期间编辑商品",
    editedProductsTrend: "编辑商品趋势",
    salesTrend: "销售趋势",
    unitsSold: "销量",
    salesAmount: "销售额",
    activeProducts: "动销商品",
    activeRate: "动销率",
    topProducts: "热销商品",
    productName: "商品名称",
    share: "占比",
    statuses: {
      all: "全部商品",
      in_sales: "在售",
      stop_selling: "停售",
    },
  },
  statisticsCommissions: {
    title: "佣金统计",
    createdCount: "期间新增笔数",
    createdAmount: "期间新增金额",
    count: "笔数",
    amount: "金额",
    status: "状态",
    agent: "代理",
    byStatus: "按状态分布",
    topAgents: "代理排行",
    buckets: {
      all: "全部状态",
      pending: "待结算",
      frozen: "冻结",
      processing: "处理中",
      paid: "已打款",
    },
    orderTypes: {
      all: "全部类型",
      normal: "普通订单",
      lottery: "抽奖",
      server: "服务订单",
    },
    levels: {
      all: "全部层级",
      1: "一级",
      2: "二级",
      3: "三级",
    },
  },
  statisticsTransfers: {
    title: "转账统计",
    totalCount: "转账笔数",
    totalAmount: "转账金额",
    successCount: "成功笔数",
    successAmount: "成功金额",
    failedCount: "失败笔数",
    pendingCount: "处理中",
    waitConfirmCount: "待确认",
    usage: "已用额度",
    transferCount: "笔数",
    accounts: "账户用量",
    types: {
      all: "全部类型",
      commission: "佣金提现",
      manual: "手动转账",
    },
    statuses: {
      all: "全部状态",
      success: "成功",
      pending: "处理中",
      failed: "失败",
      wait_confirm: "待确认",
    },
    retryTransfers: "重试失败/待确认转账",
    retryDone: "已提交重试：成功 %{retried} 笔，跳过 %{skipped} 笔，失败 %{failed} 笔",
    users: "收款用户统计",
    userName: "姓名",
    userMobile: "手机号",
    sentAmount: "已到账",
    waitingAmount: "待确认",
    failedAmount: "失败金额",
    pendingAmount: "处理中金额",
  },
  selectLang: {
    zh: "简体中文",
    ug: "ئۇيغۇرچە",
    currentTitle: "当前语言",
    availableTitle: "可选语言",
    switchConfirm: "确定要选择该语言吗？",
  },
  importExecl: {
    importing: "正在导入表格...",
    historyItemStatusSuccess: "导入成功",
    historyItemStatusFailed: "导入失败",
    errorTitle: "错误原因",
  },
  productUnit: {
    ugName: "维文名称",
    zhName: "中文名称",
    ugNameHint: "请输入维文名称",
    zhNameHint: "请输入中文名称",
    actions: "操作",
    editAction: "编辑",
    deleteAction: "删除",
    add: "添加单位",
    edit: "编辑单位",
    deleteConfirm: "确定删除该单位吗？",
    saveSuccess: "保存成功",
    deleteSuccess: "删除成功",
  },
  productImport: {
    productCount: "商品数",
    downloadTemplate: "下载导入模板",
  },
  sales: {
    upload: "上传",
    status: "开启状态",
    submit: "提交表单",
    generate: "生成小程序",
    deleteWarning: "确定删除吗？",
    zhTitleWarning: "请填写中文标题",
    zhTitle: "中文标题",
    ugTitleWarning: "请填写维文标题",
    ugTitle: "维文标题",
    save: "保存草稿",
    localOk: "继续编辑",
    localNew: "重新开始",
    localWarning: "您有未上传的活动信息，是否继续？",
    priceLabel: "原价￥%{original_price}元,现价￥%{price}元",
    ad: {
      lottery: "转盘",
      live: "直播",
      webview: "网页",
      add: "添加广告",
      weapp: "小程序",
      appId: "小程序APP_ID",
      typeWarning: "请选择广告类型",
      product: "商品",
      holiday: "活动",
      ranking: "代理排行榜",
      market: "店铺",
      groupon: "抢购",
      title: "广告编辑",
      order: "广告顺序",
      orderPlace: "数值越大越靠前",
      zhImg: "中文图片",
      ugImg: "维文图片",
      imgWarning: "缺少图片",
      type: "广告类型",
      target: "请输入广告目的地",
      show: "纯展示",
      swiperTip: "首页滑动广告位，尺寸为408px*1040px",
      splashTip: "打开小程序时首屏满屏广告",
      popupTip: "打开小程序时首页展示的跳出广告",
      homeAdTip:
        "首页商品列表上方的图片广告位，支持透明背景图片，尺寸为180px*576px",
      zhDescription: "中文描述",
      ugDescription: "维文描述",
      isDark: "深色模式",
      isVideo: "使用视频",
      adHeight: "轮播高度",
      adHeightPlace: "屏幕高度百分比 (1-100)",
      adHeightExtra: "留空则使用店铺设置中的轮播图高度",
      ugVideo: "维文视频",
      zhVideo: "中文视频",
    },
    activity: {
      add: "添加活动",
      addTheme: "添加模版",
      product: "添加商品",
      title: "活动编辑",
      zhImg: "中文图片",
      ugImg: "维文图片",
      imgWarning: "缺少图片",
      edit: "编辑活动",
      delete: "删除",
      today: "今天",
      start_date: "开始",
      end_date: "结束",
      addProduct: "添加商品",
      time: "活动时间",
      product_list: "商品列表",
      discount_price: "活动价（元）",
      discountWarning: "请输入活动价",
      min: "最低限购",
      minWarning: "请输入最低限购",
      max: "最高限购",
      maxWarning: "请输入最高限购",
    },
    groupon: {
      title: "团购",
      deals: "套餐管理",
      orders: "订单管理",
      addDeal: "添加套餐",
      editDeal: "编辑套餐",
      deal: "套餐",
      originalPrice: "原价（元）",
      salePrice: "售价（元）",
      neededPoints: "所需积分",
      neededPointsRequired: "请输入所需积分",
      validDays: "有效天数",
      includedItems: "包含项目",
      addItem: "添加项目",
      points: "积分",
      cash: "现金",
      verify: "核销",
      verified: "核销成功",
      refund: "退款",
      refunded: "退款成功",
      enterToken: "输入核销码",
      redeemToken: "核销码",
      expiresAt: "过期时间",
      statusPending: "待付款",
      statusPaid: "待核销",
      statusRedeemed: "已核销",
      statusRefunded: "已退款",
      statusLabel: {
        0: "待付款",
        1: "待核销",
        2: "已核销",
        3: "已退款",
        4: "已取消",
      },
      zhName: "中文名称",
      ugName: "维语名称",
      zhDescription: "中文描述",
      ugDescription: "维语描述",
      sortOrder: "排序",
      edit: "编辑",
      delete: "删除",
      save: "保存",
      cancel: "取消",
      back: "返回",
      detail: "详情",
      all: "全部",
      search: "搜索",
      active: "上架",
    },
    nav: {
      add: "添加导航",
      title: "导航编辑",
      order: "显示顺序",
      orderPlace: "数值越大显示越靠前",
      target: "链接页面",
      targetWarning: "请选择链接页面",
      img: "图片",
      imgWarning: "缺少图片",
      coupon: "优惠券页面",
      product: "商品分类页面",
      childTab: "分类",
      orders: "全部订单页面",
      discount: "特价商品页面",
      liveList: "直播房间列表页面",
      liveRoom: "直播房间页面",
      mediaUrl: "获取回放地址",
      roomId: "房间号",
      roomIdWarning: "请输入房间号",
      couponIdWarning: "请选择优惠券",
      imgTip:
        "首页滑动广告下面的分类入口，支持透明背景图片，尺寸为 300px*300px",
      showText: "显示文字",
      iconHeight: "图标高度",
      iconHeightPlace: "请输入图标高度（像素）",
    },
    mini: {
      name: "小程序名称",
      shortName: "小程序简称",
      description: "小程序简介",
      img: "小程序头像",
      primary: "主颜色",
      secondary: "副颜色",
      testTitle: "测试标题",
      testBtnTitle: "测试按钮",
      nameWarning: "名称不能为空",
      appIdWarning: "AppId不能为空",
      appSecretWarning: "AppSecret不能为空",
      tokenWarning: "Token不能为空",
      aesKeyWarning: "AESKey不能为空",
      descriptionWarning: "小程序简介不能为空",
      imgWarning: "头像不能为空",
      mainConfig: "小程序配置",
      secondConfig: "小程序设置",
      paymentConfig: "支付设置",
      zhTitle: "中文标题",
      ugTitle: "维文标题",
      language: "首选语言",
      live: "直播开关",
      ug: "维语",
      zh: "中文",
      theme: "主题",
      dark: "深色",
      light: "浅色",
      navBarBgColor: "导航栏背景颜色",
      navBarTextColor: "导航栏文字颜色",
      settingWarning: "请完成小程序配置并提交以后在设置小程序设置",
    },
    coupons: {
      add: "添加优惠券",
      send: "发放",
      title: "优惠券编辑",
      price: "优惠金额（元）",
      limit: "满多少（元）",
      range: "发放日期",
      experation: "过期日期",
      expireDays: "领取后有效天数",
      expireDaysUnit: "天",
      expireDaysHint: "用户领取后，在该天数内可使用",
      expireDaysWarning: "请填写有效天数",
      claimLimit: "每人限领张数",
      claimLimitHint: "0 表示不限次数",
      claimLimitWarning: "请填写限领张数",
      usageNoticeZh: "使用须知（中文）",
      usageNoticeUg: "使用须知（维语）",
      priceWarning: "请输入优惠金额",
      limitWarning: "请输入订单总额",
      rangeWarning: "请选择发放日期",
      experationWarning: "请选择过期日期",
      select: "选择",
      selected: "已选择",
      quantity: "发放数量",
      quantityWarning: "请填写数量",
      status: "状态",
      total: "全部数量%{count}张",
      left: "剩余数量%{count}张",
      start: "满%{price}元使用",
      face_price: "优惠%{price}元",
      no_limit: "无门槛",
      all: "全部",
      used: "已使用",
      unused: "未使用",
      distributedDate: "发放日期",
      distributedList: "发放记录",
      duplicate: "复制",
      duplicateTitle: "复制优惠券",
      duplicateNameSuffix: " (复制)",
      usedDate: "使用日期",
      orderNo: "订单编号",
      isPublic: "是否公开",
      selectedCount: "已选 %{count} 个",
      showAllSelected: "查看全部 (%{count})",
    },
    gift: {
      add: "添加赠品",
      edit: "编辑赠品",
      product: "指定商品",
      order: "订单金额",
      type: "类型",
      orderAmount: "订单金额",
      selected: "已选商品",
      deleteAll: "全部删除",
      rangeWarning: "请选择日期",
      gift: "赠品",
      typeWarning: "请选择赠送类型",
    },
  },
  property: {
    addChild: "添加规格",
    delete: "删除规格组",
    addGroup: "添加规格组",
    newGroup: "新规格组",
    selectGroup: "请选择规格",
    submit: "提交",
    groupZh: "规格组中文名称",
    groupUg: "规格组维文名称",
    childZh: "规格中文名称",
    childUg: "规格维文名称",
    number: "货号",
    priceYuan: "价格（元）",
    priceYuanPlaceholder: "元",
    quantity: "库存",
    must: "必填",
    deleteGroup: "删除规格组会删除规格里的产品信息",
    priceWarning: "请输入价格",
    quantityWarning: "请输入数量",
    bulkFill: "批量填入，回车应用",
  },
  payment: {
    merchantId: "商户号",
    secret: "支付密钥",
  },
  agentLevel: {
    add: "添加等级",
    zh: "中文名称",
    ug: "维文名称",
    commission: "佣金",
    product: "对应产品",
    title: "代理等级佣金设置",
    selectLevels: "选择代理等级",
    commissionSettings: "佣金设置",
    selectLevel: "请选择代理等级",
    selectLevelWarning: "请选择代理等级",
    commissionWarning: "请输入佣金",
    commissionRangeWarning: "佣金必须在0-100之间",
    commissionPlaceholder: "请输入佣金",
    parentCommission: "上级佣金",
    parentCommissionWarning: "请输入上级佣金",
    parentCommissionPlaceholder: "请输入上级佣金",
    alreadySet: "已设置",
    noCommissions: "暂无佣金设置",
    addSuccess: "成功添加佣金设置",
    updateSuccess: "成功更新佣金设置",
    deleteWarning: "确定要删除此佣金设置吗？",
  },
  users: {
    select: "选择用户",
    name: "名称",
    avatar: "头像",
    tags: "是否注册",
    actions: "操作",
    unbind: "解绑微信",
    registered: "已注册",
    unregistered: "未注册",
    order: "订单数量",
    searchPlace: "请输入用户名或者手机号来搜索",
    balance: "余额",
    balanceSum: "全部余额:",
    date: "创建日期",
    unbindWarning: "确定要解除绑定吗？",
    currentBalance: "当前余额",
    topupWarning: "确定充值当前用户吗？",
    topup: "充值",
    recall: "撤销",
    recallWarning: "确定要撤销吗？",
    operator: "操作员",
    appoint: "指定用户",
    unappoint: "取消指定用户",
    confirmReducing: "确定调整此用户的余额吗",
    reduceAmount: "调整金额",
    reduceComment: "备注（可以填写银行流水号，日期等）",
    columnRequired: "必须得填写此字段哦",
  },
  live: {
    edit: "编辑直播间",
    sync: "同步直播列表",
    ugTitle: "维文标题",
    zhTitle: "中文标题",
    order: "序列",
    zh_poster_image: "中文海报图",
    ug_poster_image: "维文海报图",
    rec: "已推荐",
    zh_recommended_slider_image: "中文推荐图片",
    ug_recommended_slider_image: "维文推荐图片",
  },
  deliveryman: {
    title: "配送员管理",
    edit: "编辑配送员信息",
    add: "添加配送员",
    zhNameHint: "请填写配送员的中文名",
    zhName: "中文名",
    ugNameHint: "请填写配送员的维语名",
    ugName: "维语名",
    mobile: "手机号",
    mobileHint: "请准确输入手机号",
    mobileHolder: "请输入手机号",
    deleteWarning: "真的要删除吗？",
    atleast: "至少选择一个要绑定的小区",
  },
  community: {
    title: "区域管理",
    edit: "编辑区域信息",
    add: "添加区域",
    zhNameHint: "请填写区域的中文名",
    zhName: "中文名",
    ugNameHint: "请填写区域的维语名",
    ugName: "维语名",
    zhAddressHint: "请填写区域的中文地址",
    zhAddress: "中文地址",
    ugAddressHint: "请填写区域的维语地址",
    ugAddress: "维语地址",
    position: "坐标",
    positionHint: "请输入坐标",
    population: "人口数量",
    order: "排序",
    addMany: "批量添加小区",
    polygon: "选择区域",
    success: "成功添加小区",
  },
  deliveryZone: {
    title: "配送范围运费",
    pageHint:
      "按层级绘制配送范围：第1层为最近（最内层）。落在哪一层就按该层的起送价与运费计费；不在任何层内则无法下单。批发门店按认证坐标匹配层级。",
    add: "添加配送层级",
    edit: "编辑配送层级",
    level: "层级",
    levelHint: "请填写层级（1为最内层）",
    levelHintNested: "请先画内层，再画更大的外层；层级数字越小越靠近店铺。",
    zhName: "中文名",
    zhNameHint: "可选，如：近距离",
    ugName: "维语名",
    ugNameHint: "可选",
    isFree: "免运费",
    free: "免运费",
    shipPrice: "运费",
    shipPriceHint: "请填写运费（元）",
    startingPrice: "起送价",
    startingPriceHint: "请填写起送价（元）",
    startingPriceExtra:
      "该层级内的门店下单需达到此金额。批发场景按门店认证坐标匹配层级。",
    enabled: "启用",
    enabledOn: "启用",
    enabledOff: "停用",
    boundary: "配送边界",
    boundaryRequired: "请绘制配送边界（至少3个点）",
    startDrawing: "开始绘制",
    finishDrawing: "完成绘制",
    clear: "清除边界",
    pointCount: "点数：%{count}",
    drawingHint: "在地图上依次点击绘制多边形，完成后点击“完成绘制”。",
    idleHint: "点击“开始绘制”后在地图上画出该层级的配送范围。",
    minPoints: "至少需要3个点才能完成边界",
    deleteWarning: "确定删除该配送层级吗？",
  },
  merchantLocation: {
    title: "店铺位置",
    pageHint:
      "设置店铺在地图上的位置。该坐标用于配送范围中心，以及用户端选择收货位置时的地图中心。",
    coordinate: "坐标",
    coordinateHint: "请填写有效坐标，格式：经度,纬度",
    mapHint: "点击地图选择坐标，或在上方手动输入经度,纬度",
    mapLoadFailed: "地图加载失败，请刷新后重试",
  },
  appearance: {
    title: "主题与颜色",
    pageHint: "设置小程序主题色与深浅风格，无需填写小程序或支付配置。",
    preview: "预览",
  },
  communityBuilding: {
    title: "楼栋管理",
    manage: "楼栋",
    edit: "编辑楼栋",
    add: "添加楼栋",
    zhName: "中文名",
    ugName: "维语名",
    zhNameHint: "请填写楼栋中文名",
    ugNameHint: "请填写楼栋维语名",
    enabled: "启用",
    enabledYes: "启用",
    enabledNo: "停用",
  },
  lottery: {
    title: "抽奖活动",
    wheel: "大转盘",
    nine: "九宫格",
    fruit: "老虎机",
    product: "商品",
    coupon: "优惠券",
    thirdAppCoupon: "第三方优惠券",
    red: "现金",
    thanks: "谢谢参与",
    itemType: "奖品类型",
    itemTypeWarning: "请选择奖品类型",
    percent: "概率",
    remainError: "还剩%{remain}%",
    percentMessage: "概率总和一定为100%",
    add: "添加奖品",
    type: "抽奖类型",
    empty: "请添加奖品",
    redWarning: "请填写现金金额",
    prizes: "奖品池",
    prirzeTotal: "总发放数量",
    wheelWarning: "大转盘奖品数目必须为六个",
    fruitWarning: "水果机奖品数目必须为八个",
    themeWarning: "请选择抽奖模版",
    validTime: "领奖有效天数",
    validWarning: "请填写领奖有效日期",
    validRule: "自获奖日期起算，过期奖品无效",
    ticketCount: "票数",
    recommendCount: "推广数",
    recommendAmount: "推广金额",
    recommendList: "推广情况",
    recommendCommission: "推广佣金",
    currentCount: "票数记录",
    prizeCount: "抽奖记录",
    transCount: "转移记录",
    reduce: "减少票数",
    revert: "撤销转移",
    zhStartImg: "中文开始按钮",
    ugStartImg: "维文开始按钮",
    zhHeaderImg: "中文活动标题",
    ugHeaderImg: "维文活动标题",
    plateBack: "转盘背景",
    ugDesc: "维文活动规则说明",
    zhDesc: "中文活动规则说明",
    zhAwardImg: "中文获奖图片",
    ugAwardImg: "维文获奖图片",
    thumb: "整体照片",
    zhImg: "主页中文背景",
    ugImg: "主页维文背景",
    backColor: "主页背景颜色",
    imgRule: "建议图片尺寸为%{pixel}类型为%{type}",
    backColorRule: "背景颜色应选取背景图片的底色",
    sender: "发送者",
    receiver: "接受者",
    telWarning: "请输入手机号",
    receiverWarning: "请输入收货人",
    addressWarning: "请输入详细地址",
    drew_at: "抽奖时间",
    exchanged_at: "兑现时间",
    prize: "奖品",
    draw: "已抽奖",
    exchange: "已兑换",
    organSend: "官方发放",
    userTickets: "用户票数",
    ticketPrice: "票价(元)",
    ticketWarning: "请填写票价",
    toExchange: "兑换",
    exchangeAlert: "确定兑换码？",
    selfBuy: "用户是否可以自购票",
    onSite: "是否门店兑换",
    selfBuyCount: "用户自购",
    buyHistory: "购票记录",
    select: "选择",
    left: "剩余",
    prePrize: "奖品预设",
    addPrePrize: "添加预设",
    selectManager: "指定管理员",
    managers: "管理员列表",
    opened: "已开启",
  },
  redPacket: {
    zhImg: "中文红包图片",
    ugImg: "维文红包图片",
    price: "红包金额（元）",
    autoRedPacket: "自动发红包",
    specialPrize: "特殊奖品(红包)",
    count: "发放人数",
    add: "添加红包",
    update: "编辑红包",
    atLeast: "至少需要%{price}元",
    priceWarning: "请输入红包金额",
    countWarning: "请填写人数",
    list: "红包记录",
    user: "获奖用户",
    retry: "重新生成",
  },
  article: {
    add: "添加文章",
    cat: "文章分类",
    addCatPlz: "请先添加文章分类",
    title: "文章",
    all: "全部",
    opened: "已开放",
    closed: "已关闭",
    selectWarning: "请选择文章",
    tags: "标签",
    tagsPlaceholder: "选择标签",
    tagAdd: "添加标签",
    tagEdit: "编辑标签",
    editorsChoiceAdd: "添加今日词条",
    showOnDate: "展示日期",
    showOnDateRequired: "请选择展示日期",
    zhComment: "中文编辑寄语",
    ugComment: "维文编辑寄语",
    commentRequired: "请填写编辑寄语",
    video: "视频（可选）",
    videoUrl: "视频（可选）",
    defaultViews: "默认阅读数",
    realViews: "真实阅读数",
  },
  weapp: {
    add: "发布新版本",
    version: "版本",
    type: "类型",
    build: "zip文件",
    standard: "标准版",
    lottery: "抽奖版",
    course: "课程版",
    drag: "请点击选择或者把zip文件拖到这块区域",
  },
  transfer: {
    new: "打款",
    reason: "请填写备注",
  },
  applyment: {
    apply: "申请",
    applyAgain: "再次申请",
    query: "查询",
    applyDescription:
      "1.上传营业执照等证照信息 \n 2. 上传银行信息 \n 3. 填写商户基本信息 \n 4.最后申请入驻",
    procesing: "处理中",
    processingDescription: "",
    finishDescription: "",
    title: "申请微信支付商户",
    id: "申请编号",
    status: "申请状态",
    merchantId: "商家编号",
    subMerchantId: "微信支付商户编号",
    createdDate: "创建日期",
    updatedDate: "更新日期",
    check: "查询进度",
    checking: "资料校验中",
    accountNeedVerify: "待账户验证",
    auditing: "审核中",
    rejected: "已驳回",
    canceled: "已取消",
    needSign: "待签约",
    needSignHint: "请负责人使用微信扫码完成签约",
    finish: "完成",
    frozen: "已冻结",
    otherAccountsHeading: "其他微信支付商户申请",
  },
  member: {
    memberType: "会员类型",
    courseMember: "课程会员",
    allMember: "小程序会员",
    info: "会员信息",
    number: "会员编号",
    joined_at: "成为会员日期",
    expired_at: "会员到期日期",
    saved: "总共节省（元）",
    add: "新增会员",
    remove: "移除会员",
    removeConfirm: "确定将该用户从会员列表中移除吗？",
    removed: "已移除会员",
    filterMobile: "手机号",
    filterMobileHint: "输入手机号（模糊匹配视后端而定）",
    filterKeyword: "关键词",
    filterKeywordHint: "昵称等（视后端 filter[keyword] 支持）",
    filterMemberNo: "会员编号",
    filterMemberNoHint: "会员编号",
    filterMemberCard: "会员卡",
    filterMemberCardPlaceholder: "全部会员卡",
    filterCreatedAtRange: "创建时间",
    filterLast7Days: "近 7 天",
    filterLast30Days: "近 30 天",
    searchFilters: "查询",
    resetFilters: "重置",
    duration: "会员期限",
    type: "会员类型",
    user: "会员用户",
    selectUser: "选择用户",
    reselect: "重新选择",
    durationWarning: "请选择会员期限",
    cardWarning: "请选择会员类型",
    zhDesc: "中文说明",
    ugDesc: "维文说明",
    price: "会员费",
    points: "积分",
    discount: "折扣",
    multiple: "积分倍数",
    addCard: "新增会员卡",
    editCard: "编辑会员卡",
    autoGrantOnFirstOrderTitle: "首单支付后自动赠送会员卡",
    autoGrantOnFirstOrderHint:
      "用户首次成功支付商品订单后自动成为会员；该首单仍按原价结算，从第二单起享受会员折扣。代理自购仍走代理优惠（优先于会员折扣）。留空则关闭。",
    autoGrantOnFirstOrderPlaceholder: "选择要赠送的会员卡",
    paidAt: "付费时间",
    independentCommission: "是否设置单独分销比例",
    memberAdventages: "会员权益信息",
    shouldAllCourseFree: "是否可以免费观看所有课程",
    shouldAllCourseFreeDescription:
      "开通后购买此会员卡的用户可以免费观看所有课程。如果您的小程序没有课程功能，请忽略",
    discountDescription:
      "此类您的小程序中购买商品时会享受的折扣，相当于如果你填写了10%， 则用户享受9折",
    multiplePointsDescription:
      "如果您的小程序启动了积分，则用会员每消费1元获得的积分数量",
    giftCodes: {
      title: "会员礼品码活动",
      docReference:
        "接口说明见仓库内文档 docs/member-gift-codes-api.md（商家端为 member API）。",
      batchNumber: "批次号",
      batchNumberRequired: "请填写批次号",
      quantityRequired: "请填写生成数量",
      memberCard: "会员卡",
      quantity: "码数量",
      status: "状态",
      export: "导出文件",
      statusUnknown: "未知",
      statusCreated: "草稿（可编辑）",
      statusGeneratingCodes: "生成码中",
      statusGeneratedCodes: "码已就绪",
      statusGeneratingExcel: "导出表格中",
      statusGeneratedExcel: "导出完成",
      createActivity: "新建活动",
      editActivity: "编辑活动",
      codesTitle: "兑换码列表",
      codeValue: "兑换码",
      userId: "用户 ID",
      redeemedAt: "兑换时间",
      filterKeyword: "按兑换码搜索",
      filterRedeemed: "兑换状态",
      filterRedeemedYes: "已兑换",
      filterRedeemedNo: "未兑换",
      applyFilters: "筛选",
      refreshList: "刷新列表",
      autoRefresh: "每 5 秒自动刷新",
      stopAutoRefresh: "停止自动刷新",
      pollStarted: "已开始定时刷新列表状态",
      pollStopped: "已停止定时刷新",
      saveSuccess: "已保存",
      deleteSuccess: "已删除",
      deleteConfirm: "确定删除该礼品码活动吗？仅草稿可删除。",
      onlyDraftEditable: "仅草稿状态的活动可以编辑。",
      onlyDraftDeletable: "仅草稿状态的活动可以删除。",
      confirmGenerateCodes:
        "将向队列提交生成兑换码任务，确定继续吗？生成完成后请刷新或开启自动刷新查看状态。",
      confirmGenerateExcel:
        "将导出兑换码 Excel（异步任务），确定继续吗？完成后可下载压缩包。",
      generateCodes: "生成兑换码",
      generateExcel: "导出 Excel",
      downloadExcel: "下载导出文件",
      viewCodes: "查看兑换码",
      jobQueued: "任务已提交",
    },
  },
  media: {
    supportedImageType: "支持类型：%{imageType}",
    supportedAudioType: "支持类型：%{audioType}",
    supportedVideoType: "支持类型：%{videoType}",
    fileName: "文件名称",
    upload: "点击上传",
    fileInfo: "文件信息",
    size: "大小",
    newFolder: "新增目录",
    folderName: "目录名称",
    rename: "重命名",
    addSubFolder: "增加子目录",
    deleteFolder: "删除目录",
    selectedRows: "您选择了%{count}个内容",
    saveFinished: "恭喜您，成功更新了",
    selectVideo: "选择视频",
    selectImages: "选择图片",
    selectAudio: "选择音频",
  },
  course: {
    title: "课程管理",
    otherTitle: "课程相关信息",
    titleArticle: "图文课程管理",
    titleAudio: "音频课程管理",
    titleVideo: "视频课程管理",
    edit: "编辑课程",
    add: "新增课程",
    addArticle: "新增图文课程",
    addAudio: "新增音频课程",
    addVideo: "新增视频课程",
    editArticle: "编辑图文课程",
    editAudio: "编辑音频课程",
    editVideo: "编辑视频课程",
    basicInfo: "基本信息",
    saleInfo: "售卖方式",
    commissionInfo: "分销设置",
    otherInfo: "其他设置",
    ugName: "标题 (维语）",
    name: "课程标题",
    zhName: "标题（汉语）",
    ugSubTitle: "简介（维语）",
    zhSubTitle: "简介（汉语）",
    selectTeacher: "选择老师",
    selectCategory: "选择分类",
    goToTeachers: "前往教师管理",
    goToCategories: "前往分类管理",
    ugBrief: "试看图文 (维语）",
    zhBrief: "试看图文 (汉语）",
    ugDescription: "课程详情 (维语）",
    zhDescription: "课程详情 (汉语）",
    ugAntiFraudDescription: "反诈说明 (维语）",
    zhAntiFraudDescription: "反诈说明 (汉语）",
    defaultView: "默认观看次数",
    actualView: "实际观看次数",
    defaultSold: "默认销量",
    actualSold: "实际销量",
    marketPrice: "市场价格",
    price: "价格",
    notForSale: "非卖品",
    forSale: "可售",
    saleTypeFilter: "售卖类型",
    status: "上架状态",
    statusActive: "立即上架",
    statusInActive: "暂不上架",
    commissionPercent: "佣金比例",
    parentCommissionPercent: "父代佣金比例",
    validDate: "有效期限",
    validForever: "长期有效",
    validDays: "购买后有效天数",
    cover: "课程封面",
    zhCover: "课程封面（汉语）",
    ugCover: "课程封面（维语）",
    zhPortraitCover: "课程竖屏封面（汉语）",
    ugPortraitCover: "课程竖屏封面（维语）",
    zhMindmap: "课程思维导图（汉语）",
    ugMindmap: "课程思维导图（维语）",
    teacherLabel: "老师:",
    courseInfo: "课程信息",
    categoryName: "课程分类",
    studyStatus: "学习情况",
    batchOnShelf: "批量上架",
    batchOffShelf: "批量下架",
    batchSetCategory: "批量设置分类",
    batchSelectWarning: "请先选择要操作的课程",
    selectCategoryWarning: "请选择分类",
    selectedCount: "已选择 %{count} 个课程",

    teacher: {
      title: "教师管理",
      name: "姓名",
      ugName: "姓名 (维语）",
      zhName: "姓名（汉语）",
      add: "新增老师",
      edit: "编辑老师",
      gender: "性别",
      male: "男",
      female: "女",
      ugDescription: "讲师介绍（维语）",
      zhDescription: "讲师介绍（汉语）",
    },
    category: {
      title: "分类管理",
      name: "名称",
      ugName: "名称(维语）",
      zhName: "名称（汉语）",
      add: "新增分类",
      edit: "编辑分类",
    },
    lesson: {
      title: "课时管理",
      name: "课时名称",
      ugName: "课时名称(维语）",
      zhName: "课时名称（汉语）",
      add: "新增课时",
      edit: "编辑课时",
      duration: "时长",
      trial: "试看开关",
      trialDuration: "试看时长（秒）",
      lessonVideo: "课时视频",
      lessonAudio: "课时音频",
    },
    student: {
      studyLevel: "学习进度",
      add: "添加学员",
      info: "学员信息",
      studyTime: "学习时长",
      studyProgress: "学习进度",
      validTime: "有效期",
      validForever: "长期有效",
      customDate: "自定义期限",
      customDateLabel: "自定义到期时间",
    },
    comment: {
      title: "评论管理",
    },
    order: {
      title: "课程订单管理",
      customerInfo: "客户信息",
      paidAt: "下单时间",
      price: "金额",
      realPayment: "实付金额",
      detail: "订单详情",
      idLabel: "订单号：",
      transactionIdLabel: "交易单号：",
      statusLabel: "订单状态：",
      createTimeLabel: "下单时间：",
      payTimeLabel: "付款时间：",
      avatarLabel: "用户头像：",
      nicknameLabel: "用户昵称：",
      telLabel: "联系电话",
      realPaymentLabel: "实际支付：",
      commissionInfoLabel: "分销信息：",
      commissionLabel: "分销员佣金",
      parentCommissionLabel: "父代佣金",
    },
    sliderAd: {
      title: "课程首页滑动广告",
      add: "新增广告",
      edit: "编辑广告",
      name: "广告名称",
    },
    album: {
      title: "课程专辑",
      add: "新增专辑",
      edit: "编辑专辑",
      name: "专辑名称",
      category: "专辑分类",
      price: "专辑价格",
      marketPrice: "市场价格",
      originalPrice: "原价",
      courses: "课程",
      selectCourses: "选择课程",
      coursesCount: "课程数量",
      batchOnShelf: "批量上架",
      batchOffShelf: "批量下架",
      batchSetCategory: "批量设置分类",
      batchDelete: "批量删除",
      selectedCount: "已选择 %{count} 个专辑",
      addCourses: "添加课程",
      removeCourse: "移除课程",
      courseSelection: "课程选择",
      totalCoursesPrice: "课程总价",
      albumPrice: "专辑价格",
      discount: "折扣",
      validForever: "永久有效",
      validDays: "有效天数",
      status: "上架状态",
      statusOnShelf: "已上架",
      statusOffShelf: "已下架",
      sales: "销量",
      views: "浏览量",
      order: "排序",
      cover: "封面",
      zhCover: "中文封面",
      ugCover: "维文封面",
      description: "描述",
      zhDescription: "中文描述",
      ugDescription: "维文描述",
      basicInfo: "基本信息",
      pricing: "价格设置",
      settings: "其他设置",
      courseManagement: "课程管理",
      noCourses: "暂无课程",
      confirmRemoveCourse: "确定要移除该课程吗？",
      selectCategoryWarning: "请选择分类",
      batchSelectWarning: "请先选择要操作的专辑",
      cannotDeleteWithOrders: "该专辑有订单，无法删除",
    },
  },
  link: {
    title: "链接选择器",
    select: "选择",
    deSelect: "取消选择",
    platformLinks: "平台页面",
    selectedProductCategory: "产品分类~%{category}",
    selectedProduct: "产品~%{product}",
    selectedCourseCategory: "课程分类~%{category}",
    selectedCourse: "课程~%{course}",
    selected: "已选择",
    products: "产品列表",
    coursesCategories: "课程分类",
    courses: "课程列表",
    courseAlbums: "课程专辑",
    weapp: "小程序跳转",
    wechatAppId: "微信小程序APPID",
    wechatPath: "微信小程序路径",
    webview: "网页广告",
    webviewUrl: "网页地址",
  },
  qrcode: {
    type: "活动类型",
    activity: "活动",
    title: "一物一码",
    listTitle: "一物一码列表",
    name: "名称",
    ugName: "名称（维语）",
    zhName: "名称(汉语）",
    batch: "批次",
    quantity: "数量",
    palletCapacity: "托盘容量",
    cartoonCapacity: "大箱容量",
    boxCapacity: "小箱（盒子）容量",
    qrcodeGenerateWarning: "确定生成二维码吗？一旦生成就无法修改数量等内容",
    generateQRcode: "生成二维码",
    excelGenerateWarning: "确定生成二维码Excel吗？",
    generateExcel: "生成二维码Excel",
    add: "新增二维码",
    edit: "编辑二维码",
    generatingQrcode: "正在生成二维码",
    qrcodeDetailList: "查看二维码列表",
    generatingExcel: "正在生成Excel",
    downloadExcel: "下载Excel",
    prize: "奖品",
    type: "二维码类别",
    redPacketAmount: "红包金额",
    regionName: "所在区域",
    scannedAt: "扫码时间",
    drawndAt: "中奖时间",
    exchangedAt: "兑奖时间",
    priority: "优先级",
    priorityRule: "数字越大优先级越高",
    selectQrcode: "选择一物一码",
    goToQrcodes: "前往一物一码管理",
    selectRegion: "选择地区",
    regionRule: "如果需要限制地区，请选择相应地区",
    redPacket: "红包",
    redPacketWarning: "请填写红包金额",
    productOnSite: "再来一个产品",
    point: "积分",
    redPaketWarning: "请填写现金金额",
    pointWarning: "请填写积分数量",
    specialPrize: "不参与基础抽奖",
    expensePoints: "单次抽奖消耗积分",
    expensePointsRule: "只有积分抽奖的时候才会消耗积分",
    onHowManyTimes: "第几次抽奖抽中该奖品",
    customer: "客户类型",
    prize: "奖品类型",
    client: "消费者活动",
    shop: "店铺活动",
    prizeZero: "每次抽奖",
    prizeOne: "第一次抽奖,后续赠送积分",
    prizeTwo: "每次赠送积分",
    store: "店铺",
    applyDate: "申请时间",
    approveDate: "审核时间",
    signboard: "店铺招牌",
    license: "营业执照",
    idCard: "身份证",
    rejectReason: "拒绝原因",
    agreement: "协议",
    zhAgreement: "协议内容（汉语）",
    ugAgreement: "协议内容（维语）",
    typeCustomer: "客户协议",
    typeStore: "店铺协议",
    addAgreement: "创建协议",
    redeemOrder: "兑奖订单",
    transferToVip: "盒子转移给代理",
    transferToVipSuccess: "转移成功，共 %{count} 件商品已归属该代理。",
    transferToVipError: "转移失败。",
    transferBoxCode: "盒子码 / 二维码",
    transferBoxCodeRequired: "请输入盒子码",
    transferBoxCodePlaceholder: "扫码或输入 secure_code / 加密码",
    transferSelectVip: "选择VIP",
    transferSelectVipRequired: "请选择VIP",
    transferSelectVipPlaceholder: "搜索或选择VIP",
    transferSubmit: "转移",
    code: "码",
    typeFilterAll: "全部类型",
    typeFilterBox: "盒子",
    typeFilterProduct: "商品",
    filterByOwnership: "归属",
    ownershipAll: "全部",
    ownershipOwned: "已归属",
    ownershipUnassigned: "未归属",
    userMobile: "用户手机",
    itemCode: "物品码",
    vipUserItems: "用户物品",
    vipUserItemsSubtitle: "按批次与盒子分组",
    totalBoxes: "盒子数",
    totalProducts: "商品数",
    otherProductGroup: "其他商品",
  },
  tuangou: {
    shop: "店铺列表",
    location: "所在位置",
    tuanzhang: "店长",
    addShop: "新增店铺",
    address: "地址",
    coordinate: "坐标",
    latitude: "维度",
    longitude: "经度",
    info: "店铺信息",
    sliderAd: {
      title: "店铺页滑动广告",
    },
  },
  recommender: {
    title: "推广人",
    qrcode: "二维码",
  },
  redPacketActivity: {
    title: "红包活动",
    add: "创建红包活动",
    name: "活动名称",
    date: "活动时间",
    redPacket: "红包明细",
    items: "红包列表",
    generate: "生成红包",
    amount: "红包金额",
    specialAmountDescription: "特殊奖品的金额或者价值",
    amountDescription: "总发放金额，最多不能超过10万元，最少不能少于10元",
    average: "每人平均¥%{average}",
    min: "最少金额",
    max: "最多金额",
    quantity: "红包数量",
    type: "红包类型",
    specialPrizeDescription: "如果是特殊奖品，可以选择对应的奖品",
    typeDescription:
      "如果选择随机红包，红包会按照最高和最低金额来生成随机红包，每个人都可能不一样",
    typeSame: "每份都一样",
    typeRandom: "随机红包",
    receivedAt: "获奖时间",
  },
  merchantStaff: {
    title: "员工管理",
    add: "添加员工",
    edit: "编辑员工",
    name: "姓名",
    mobile: "手机号",
    status: "状态",
    statusActive: "启用",
    statusInactive: "停用",
    searchPlaceholder: "姓名 / 手机号",
    passwordHintCreate: "留空则默认密码为 123456",
    passwordHintEdit: "留空则不修改密码",
  },
  bd: {
    employee: {
      title: "业务员管理",
      add: "新增业务员",
      edit: "编辑业务员",
    },
  },
  admin: {
    profitSharingReconciliation: {
      title: "分账待结算排查",
      description:
        "对比微信商户账户 pending/available 与订单未完成分账金额，列出可疑订单并支持同步、请求完结。默认列表仅含已完成（或退款清理后）订单；进行中订单请切换「进行中」范围或用订单 ID 搜索。",
      currentMerchant: "当前商户",
      refreshWechatBalance: "从微信刷新余额",
      balanceRefreshed: "微信余额已刷新",
      statsTitle: "分账账户统计",
      balanceUpdatedAt: "微信余额更新时间：%{time}",
      gapTitle: "账户 pending 与 DB 汇总不一致",
      gapDescription:
        "实际待排查 pending %{realPending} = 微信 pending %{pending} − 进行中 DB %{inProgressDb}。需排查差额（已完成 stale/refund）%{residualGap} = pending − 已完成 DB %{completedDb} − 进行中 DB %{inProgressDb}。旧 pending 差额（仅减已完成 DB）%{legacyGap}。",
      orderIdFilter: "订单 ID",
      noIssues: "无问题",
      syncOrder: "同步",
      syncRefundedCleanup: "退款清理",
      requestFinish: "请求完结",
      actionSuccess: "操作成功",
      refundRefunded: "已退款",
      refundInProgress: "退款中",
      finishRequiresCompleted: "订单未完成，暂不能请求完结",
      bulkSync: {
        run: "批量同步",
        hint: "对当前范围内全部订单执行：微信发货上传、刷新 unsplit、提交分账轮次（与单行「同步」相同）",
        confirmTitle: "批量同步分账订单",
        confirmDescription:
          "将对 %{scope} 范围内的 %{count} 个订单依次同步（含微信发货上传）。订单较多时可能需要几分钟，是否继续？",
        noOrders: "当前范围内没有可同步的订单",
        clearOrderFilter: "请先清除订单 ID 筛选后再批量同步",
        resultsTitle: "批量同步结果",
        summary: "共 %{total} 单：成功 %{success}，失败 %{failed}",
        allSuccess: "已同步 %{total} 个订单",
        partialSuccess: "已同步 %{success}/%{total} 个订单，请查看失败明细",
        result: "结果",
        detail: "说明",
        done: "已同步",
      },
      bulkFinish: {
        run: "批量请求完结",
        hint: "对当前范围内全部订单依次请求完结分账（与单行「请求完结」相同；未完成订单会失败跳过）",
        confirmTitle: "批量请求完结分账",
        confirmDescription:
          "将对 %{scope} 范围内的 %{count} 个订单依次请求完结。订单较多时可能需要几分钟，是否继续？",
        noOrders: "当前范围内没有可完结的订单",
        clearOrderFilter: "请先清除订单 ID 筛选后再批量请求完结",
        resultsTitle: "批量请求完结结果",
        summary: "共 %{total} 单：成功 %{success}，失败 %{failed}",
        allSuccess: "已请求完结 %{total} 个订单",
        partialSuccess: "已请求完结 %{success}/%{total} 个订单，请查看失败明细",
        result: "结果",
        detail: "说明",
        done: "已请求完结",
      },
      scopes: {
        flagged: "待查（已完成：未同步或 pending>0）",
        pending: "DB pending > 0（已完成）",
        inProgress: "进行中（未完成订单）",
        staleZero: "DB=0 但可能仍有待结算（近180天，已完成）",
        all: "全部已完成分账订单",
      },
      stats: {
        pendingWechat: "微信 pending",
        realPending: "实际待排查 pending",
        realPendingHint:
          "实际待排查 pending = 微信 pending − 进行中 DB 未完成汇总。需排查差额 = pending − 已完成 DB − 进行中 DB（退款清理 / stale zero 目标）。",
        availableWechat: "微信 available",
        dbSumUnfinished: "已完成订单 DB 未完成汇总",
        ordersPending: "已完成 pending 订单数",
        nullUnfinished: "未同步 unfinished 订单数",
        staleZero: "stale zero 订单数",
        inProgressOrders: "进行中分账订单数",
        inProgressUnfinished: "进行中 DB 未完成汇总",
        residualGap: "需排查差额",
        pendingGap: "pending 差额（仅减已完成 DB）",
      },
      columns: {
        orderId: "订单 ID",
        createdAt: "下单时间",
        total: "订单金额",
        unfinished: "未完成分账",
        status: "订单状态",
        refund: "退款",
        issues: "问题",
        sharingRounds: "分账轮次",
        recommended: "建议操作",
        actions: "操作",
      },
      actions: {
        syncFromWechat: "从微信同步 unsplit",
        syncRefundedCleanup: "退款后分账清理",
        requestFinish: "请求完结分账",
        resolveSharingRounds: "先完成分账轮次",
        inspectOrderDebug: "订单调试查看",
        none: "—",
      },
      issues: {
        dbUnsynced: "未同步",
        dbPending: "DB pending",
        refundedStaleUnfinished: "退款未清零",
        sharingOpen: "分账未完结",
        sharingMissing: "缺分账记录",
        finishMissing: "缺 finish",
        finishOpen: "finish 未完结",
        finishBlocked: "finish 被阻塞",
        orderInProgress: "进行中",
      },
      playbook: {
        title: "pending 差额排查步骤",
        recommended: "建议执行",
        intro:
          "当微信 pending > 0 但「待查 / DB pending」列表为空时，常见原因：① DB 已清零但微信仍有 unsplit（stale zero）；② 订单仍在进行中（默认列表不显示）。按下列步骤在服务器执行 artisan 命令，再回到本页同步；进行中订单请切换「进行中」范围或搜索订单 ID。",
        staleZeroHintTitle: "当前符合 stale zero 特征",
        staleZeroHintDescription:
          "微信 pending 有值，但订单 DB 汇总为 0，且待查列表为空。本页列表无法直接定位订单，需先用 CLI 按 transaction 向微信查询 unsplit。",
        switchStaleZeroScope: "切换到 stale zero 列表",
        switchedStaleZeroScope: "已切换到「DB=0 但可能仍有待结算」范围",
        steps: {
          confirm: {
            title: "1. 确认差额",
            description: "点击上方「从微信刷新余额」，确认 pending 差额与 DB 汇总不一致。",
          },
          find: {
            title: "2. 找出仍有 unsplit 的订单（CLI）",
            description:
              "在服务器执行以下命令，按 transaction_id 向微信查询 unsplit。关注输出中的 Transactions with unsplit > 0 与 Stale DB rows。",
            batchNote: "订单量大时分批查询（调整 txn-offset）：",
          },
          syncDb: {
            title: "3. 把 DB 从微信同步回来",
            description:
              "确认有 unsplit 后执行 --sync-db，刷新 orders.profit_sharing_unfinished_amount。进行中订单（如 558031、560732）在本页切换「进行中」或搜索订单 ID；已完成 stale zero 订单在「stale zero」范围。",
          },
          finish: {
            title: "4. 完结分账",
            description:
              "对每个订单：先完成分账轮次（payment fee / agent），再在本页点「请求完结」，或去掉 --no-finish 让 CLI 尝试 finish。",
          },
          refund: {
            title: "5. 退款订单清理（如适用）",
            description: "若输出或列表中有已退款但 unfinished 未清零的订单，执行退款清理或在本页点「退款清理」。",
          },
          interpret: {
            title: "6. 结果解读",
            match: "sum(unsplit) ≈ pending 差额 → 同步 DB 后按订单 finish 即可。",
            less: "sum(unsplit) < pending → 可能有更旧订单或未入库 transaction，扩大 --all-time 或分批 txn-offset。",
            zero: "sum(unsplit) = 0 但 pending 仍 > 0 → 可能为非订单类 pending，需查 orphan transaction 或联系微信。",
          },
        },
      },
    },
    orderDebug: {
      title: "订单调试",
      description: "根据订单 ID 查询订单的调试信息（含支付、分账、退款等）。仅限超级管理员使用。",
      orderIdPlaceholder: "输入订单 ID",
      enterOrderId: "请输入订单 ID",
      invalidOrderId: "请输入有效的订单 ID",
      fetchFailed: "获取失败",
      error: "错误",
      result: "调试数据",
      rawJson: "原始 JSON",
      itemCount: "共 %{count} 条",
      sections: {
        order: "订单信息",
        wechatPay: "微信支付",
        combineOrderDetails: "合并支付明细",
        refunds: "退款记录",
        combineOrderRefundDetails: "合并退款明细",
        wechatProfitSharing: "微信分账",
        wechatProfitSharingFinish: "微信分账完成",
        bulutBazarAgentCheckoutRecords: "代理核销记录",
        bulutBazarMerchantCheckoutRecords: "商家核销记录",
        vipCommissions: "VIP 佣金",
        commissionWithdrawals: "佣金提现",
        sharingPlan: "分账计划",
        agentSharingDiagnostics: "代理分账 / 提现检查",
        wechatSettlement: "微信发货 / 结算",
      },
      syncWeChat: "同步微信发货与分账",
      syncSuccess: "已同步微信发货并刷新分账状态",
      syncFailed: "同步失败",
      wechatSettlementWaiting: "等待微信 48 小时结算窗口",
      wechatSettlementReady: "微信结算窗口已过",
      wechatSettlementStatus: "微信发货 / 结算状态",
      sharingDeferralReasons: "分账暂缓原因（微信未就绪）",
      agentSharingEligible: "可以创建佣金提现（代理分账）",
      agentSharingBlocked: "暂不能创建佣金提现",
      agentSharingNotRequired: "无需微信代理分账",
      recommendedCommand: "建议命令",
      finishBlockers: "完结阻塞项",
      checklist: "检查清单",
      checkPassed: "通过",
      checkFailed: "未通过",
      agentSharingChecks: {
        profit_sharing_order: "分账订单",
        commission_rows_exist: "VIP 佣金记录",
        commission_status_eligible: "佣金状态可处理",
        no_blocking_withdrawal: "无阻塞中的提现",
        withdraw_to_balance_disabled: "非余额提现商户",
        agent_transfer_on_accept: "接单转账模式",
        frozen_commission_early_sharing: "冻结佣金 / 提前分账",
        frozen_commission_delivery_48h: "发货满 48 小时",
        frozen_commission_ok: "冻结佣金检查",
        exceed_shareable_status: "超出可分账上限状态",
        within_shareable_budget: "佣金在预算内",
        agent_round_prerequisites: "代理轮次前置条件",
        order_status_delivery: "发货后分账订单状态",
        order_status_accept: "接单后分账订单状态",
        order_status_accept_transfer: "接单转账订单状态",
        complete_order_after_days: "收货后等待天数",
        cron_60_day_window: "Cron 60 天窗口",
        agent_sharing_record: "微信代理分账记录",
        self_commission_settled_at_checkout: "自购佣金已在下单时结算",
      },
      fields: {
        orderId: "订单 ID",
        order_no: "订单号",
        price: "商品金额",
        ship_price: "运费",
        total: "合计",
        createdAt: "创建时间",
        merchantId: "商家 ID",
        merchantName: "商家名称",
        profitUnfinishedAmount: "未完成分账金额",
        level: "佣金层级",
        level_label: "层级说明",
        status: "状态码",
        status_label: "状态",
        isProfitSharingOrder: "是否分账订单",
        isCombineOrder: "是否合并订单",
        received_at: "收货时间",
        delivering_at: "发货时间",
        merchantSettings: "商户佣金设置",
        uncheckoutCommissionTotal: "未核销佣金合计",
        maxAgentCommission: "代理佣金上限",
        agentRoundBlocker: "代理轮次阻塞",
        uploadDeliveryEnabled: "启用微信发货上传",
        deliveringAt: "发货时间",
        settlementReady: "结算窗口已过",
        minutesUntilSettlementReady: "距结算就绪（分钟）",
        settlementAt: "预计结算就绪时间",
        awaitingWechatSettlement: "等待微信结算",
        profitSharingRequestLocked: "分账请求锁定",
        profitSharingLockExpiresAt: "分账锁到期时间",
        sharingDeferralReasons: "分账暂缓原因",
        pendingSharingRows: "未完成分账轮次",
        deliveryUploads: "微信发货上传记录",
        transactionId: "微信支付单号",
        context: "触发来源",
        shippingSuccess: "发货信息上传",
        confirmReceiveSuccess: "确认收货通知",
        shippingErrcode: "发货错误码",
        shippingErrmsg: "发货错误信息",
        confirmErrcode: "确认收货错误码",
        confirmErrmsg: "确认收货错误信息",
        uploadedAt: "上传时间",
        closeReason: "关闭 / 暂缓原因",
        profitSharingOrderId: "微信分账单号",
        outOrderNo: "商户分账单号",
        shareAfterDelivery: "发货后分账",
        shareAfterAccept: "接单后分账",
        enableWithdrawToBalance: "提现到余额",
        agentTransferOnAccept: "接单时转账",
        id: "ID",
        order_id: "订单 ID",
        out_trade_no: "商户订单号",
        transaction_id: "微信支付单号",
        prepay_id: "预支付 ID",
        trade_type: "交易类型",
        total_fee: "支付金额",
        number: "序号",
        appid: "AppID",
        type: "类型",
        success_time: "支付成功时间",
        sub_mchid: "子商户号",
        merchant_id: "商家 ID",
        total_amount: "支付金额",
        merchant_name: "商家名称",
        total_price: "订单金额",
        refund_price: "退款金额",
        out_refund_no: "退款单号",
        refund_id: "微信退款单号",
        reason: "退款原因",
        failed_reason: "失败原因",
        finish_amount: "分账金额",
        close_reason: "关闭原因",
        out_order_no: "分账单号",
        order_type: "订单类型",
        user_id: "用户 ID",
        commission: "佣金金额",
        commissionDetails: "佣金明细",
        commission_id: "佣金 ID",
        product_id: "商品 ID",
        original_price: "原价",
        amount: "数量",
        commission_percent: "佣金比例",
        profit_sharing_order_id: "微信分账单号",
        profit_sharing_type: "分账类型",
        details: "分账明细",
        wechat_profit_sharing_id: "分账 ID",
        receiver_mchid: "接收方商户号",
        fail_reason: "失败原因",
        description: "说明",
        coupon_id: "优惠券 ID",
        order_date: "订单日期",
        product_price: "商品金额",
        product_price_payment_fee: "商品支付手续费",
        ship_price_payment_fee: "运费支付手续费",
        packing_price: "包装费",
        packing_price_payment_fee: "包装费支付手续费",
        platform_ratio: "平台比例",
        deliver_by_us: "平台配送",
        payment_fee: "支付手续费",
        platform_income: "平台收入",
        platform_expense: "平台支出",
        merchant_income: "商家收入",
        merchant_expense: "商家支出",
        bb_agent_expense: "代理支出",
        bb_agent_income: "代理收入",
        v2Enabled: "V2 分账逻辑已启用",
        lastRoundType: "最后分账轮次",
        hasAgentCommission: "有代理佣金",
        hasSpecialShare: "有特殊分账",
        budget: "分账预算",
        rounds: "分账轮次",
        legacyComparison: "旧逻辑对比",
        required: "必需",
        finish: "本轮完结",
        sharingStatus: "分账状态",
        sharingId: "分账记录 ID",
        estimatedAmount: "预估金额",
        orderTotal: "订单总额",
        maxSharable: "微信最大可分账",
        safeMaxCommission: "安全佣金上限",
        maxAgentCommission: "代理佣金上限",
        paymentFee: "手续费",
        specialShare: "特殊分账",
        agentCommission: "代理佣金",
        totalPlannedShare: "计划分账合计",
        remainingForMerchant: "商家留存",
        exceedsWechatLimit: "超出微信上限",
        payment_fee: "手续费",
        agent: "代理佣金",
        special: "特殊分账",
        paymentFeeWouldFinish: "旧逻辑-手续费后完结",
        agentWouldFinish: "旧逻辑-代理后完结",
        specialWouldFinish: "旧逻辑-特殊分账后完结",
        created_at: "创建时间",
        updated_at: "更新时间",
        wechat_profit_sharing_detail_id: "分账明细 ID",
        merchant_expense_detail: "商家支出明细",
        agent_expense_detail: "代理支出明细",
        platform_expense_detail: "平台支出明细",
        status_change_log: "状态变更日志",
        status_history: "状态历史",
        combine_order_detail_id: "合并订单明细 ID",
        agent_id: "代理 ID",
        agent_snap: "代理快照",
      },
    },
  },
  video: {
    title: "视频管理",
    submenuVideos: "视频列表",
    add: "添加视频",
    edit: "编辑视频",
    name: "视频名称",
    ugCover: "维吾尔语封面",
    zhCover: "中文封面",
    videoFile: "视频文件",
    duration: "时长",
    batchSelectWarning: "请选择视频",
    selectedCount: "已选择: %{count}",
    views: "观看数",
    favorites: "收藏数",
    statistics: "统计数据",
    defaultViews: "默认观看数",
    defaultFavourites: "默认收藏数",
    notFound: "未找到视频",
    fileName: "文件名",
    fileSize: "文件大小",
    category: {
      title: "视频分类",
      name: "名称",
      add: "新增分类",
      edit: "编辑分类",
    },
  },
  customPage: {
    title: "自定义页面",
    create: "创建页面",
    edit: "编辑页面",
    pageType: "页面类型",
    pageTypeHome: "首页",
    pageTypeUser: "用户页",
    pageTypeVideoList: "视频列表",
    language: "语言",
    languageUyghur: "维吾尔语",
    languageChinese: "中文",
    status: "状态",
    statusDraft: "草稿",
    statusPublished: "已发布",
    version: "版本",
    publishedAt: "发布时间",
    duplicate: "复制",
    publish: "发布",
    saveDraft: "保存草稿",
    saveSuccess: "保存成功",
    publishSuccess: "发布成功",
    duplicateSuccess: "复制成功",
    saveBeforePublish: "请先保存草稿",
    publishConfirm: "确认发布",
    publishConfirmMessage: "发布后页面将对用户可见，确定要发布吗？",
    blocks: "区块列表",
    blockPalette: "区块面板",
    blockSettings: "区块设置",
    selectBlockToEdit: "请选择一个区块进行编辑",
    noBlocks: "暂无区块",
    noBlocksPreview: "暂无区块，请添加区块",
    blockTypeBanner: "轮播图",
    blockTypeProductGrid: "商品网格",
    blockTypeCategoryGrid: "分类网格",
    blockTypeNavigation: "导航",
    blockTypeVideo: "视频",
    blockTypeAdvertisement: "广告",
    blockTypeText: "文本",
    blockTypeFlashSale: "限时抢购",
    bannerItems: "轮播项",
    image: "图片",
    imageUyghur: "维吾尔语图片",
    imageChinese: "中文图片",
    linkType: "链接类型",
    linkTypeNone: "无链接",
    linkTypeProduct: "商品",
    linkTypeCategory: "分类",
    linkTypeUrl: "网址",
    linkTypePage: "页面",
    link: "链接",
    autoplay: "自动播放",
    interval: "间隔(毫秒)",
    height: "高度",
    titleUyghur: "维吾尔语标题",
    titleChinese: "中文标题",
    source: "来源",
    sourceCategory: "分类",
    sourceFeatured: "精选",
    sourceDiscounted: "折扣",
    sourceCustom: "自定义",
    sourceLatest: "最新",
    categoryId: "分类ID",
    categoryIds: "分类IDs",
    productIds: "商品IDs",
    videoIds: "视频IDs",
    columns: "列数",
    limit: "数量限制",
    showPrice: "显示价格",
    navigationIcons: "导航图标",
    icon: "图标",
    addBannerItem: "添加轮播项",
    addNavigationIcon: "添加导航图标",
    layout: "布局",
    layoutGrid: "网格",
    layoutList: "列表",
    content: "内容",
    name: "文字",
    backgroundColor: "背景颜色",
    padding: "内边距",
    flashSaleId: "限时抢购ID",
    showCountdown: "显示倒计时",
    errorMaxBlocks: "最多只能添加30个区块",
    errorMaxBanners: "最多只能添加5个轮播图区块",
    errorMaxProductGrids: "最多只能添加10个商品网格区块",
    errorMaxNavigationBlocks: "最多只能添加1个导航区块",
    errorMaxVideoSections: "最多只能添加2个视频区块",
  },
  groupon: {
    title: "团购",
    deals: "套餐管理",
    orders: "订单管理",
    addDeal: "添加套餐",
    editDeal: "编辑套餐",
    deal: "套餐",
    originalPrice: "原价（元）",
    salePrice: "售价（元）",
    neededPoints: "所需积分",
    neededPointsRequired: "请输入所需积分",
    validDays: "有效天数",
    includedItems: "包含项目",
    addItem: "添加项目",
    itemMarketPrice: "市场价（元）",
    itemQuantity: "数量",
    points: "积分",
    cash: "现金",
    verify: "核销",
    verified: "核销成功",
    refund: "退款",
    refunded: "退款成功",
    enterToken: "输入核销码",
    redeemToken: "核销码",
    expiresAt: "过期时间",
    statusPending: "待付款",
    statusPaid: "待核销",
    statusRedeemed: "已核销",
    statusRefunded: "已退款",
    statusLabel: {
      0: "待付款",
      1: "待核销",
      2: "已核销",
      3: "已退款",
      4: "已取消",
    },
    zhName: "中文名称",
    ugName: "维语名称",
    zhDescription: "中文描述",
    ugDescription: "维语描述",
    sortOrder: "排序",
    edit: "编辑",
    delete: "删除",
    save: "保存",
    cancel: "取消",
    back: "返回",
    detail: "详情",
    all: "全部",
    search: "搜索",
    active: "上架",
  },
  task: {
    add: "新建任务",
    edit: "编辑任务",
    trigger: "触发条件",
    triggerFirstPaidOrder: "首次付费下单",
    triggerUploadAvatar: "上传头像",
    triggerUpdateNickname: "修改昵称",
    visibility: "展示方式",
    visibilitySilent: "静默（自动发放）",
    visibilityVisible: "任务中心可见",
    visibilityHint:
      "静默任务不在用户任务中心展示，触发后自动完成并发放奖励；可见任务需用户领取任务、完成后领取奖励。",
    memberCard: "会员卡奖励",
    memberCardPlaceholder: "选择会员卡（可选）",
    coupons: "优惠券奖励",
    couponsPlaceholder: "选择优惠券（可多选）",
    rewardRequired: "请至少选择会员卡或一张优惠券",
    nameRequired: "请填写任务名称",
    status: "状态",
    enabled: "启用",
    disabled: "停用",
    sort: "排序",
  },
  storeMembership: {
    enableHint: "请先在商家设置中开启「批发客户门店认证」",
    storeName: "门店名称",
    user: "用户",
    address: "地址",
    storefront: "门头照",
    license: "营业执照",
    status: "状态",
    status_pending: "待审核",
    status_approved: "已通过",
    status_rejected: "已拒绝",
    status_banned: "已封禁",
    status_all: "全部",
    actions: "操作",
    approve: "通过",
    reject: "拒绝",
    ban: "封禁",
    unban: "解除封禁",
    edit: "编辑",
    delete: "删除",
    deleteConfirm: "确定删除该门店认证？删除后客户需重新提交。",
    upload: "上传",
    show: "查看",
    detailTitle: "门店认证详情",
    close: "关闭",
    location: "位置",
    noLocation: "暂无坐标",
    search: "搜索",
    searchPlaceholder: "门店名 / 手机号 / 地址",
    totalCount: "共 %{count} 条",
    approved: "已通过",
    rejected: "已拒绝",
    banned: "已封禁",
    updated: "已更新",
    deleted: "已删除",
    rejectReason: "拒绝原因（可选）",
    banReason: "封禁原因（将展示给客户）",
    banReasonRequired: "请填写封禁原因",
    storeNameRequired: "请填写门店名称",
    storefrontRequired: "请上传门头照",
    attribution: "客户归属",
    attributionAll: "全部归属",
    unassigned: "未分配",
    attributionStatsTitle: "客户归属统计",
    viewList: "查看列表",
    refresh: "刷新",
  },
};

